﻿// eslint-disable-next-line no-undef
angular.module('projectModule')
    .factory("VentilatieFactory",
        ['$log', 'ntabuilding', 'ntaValidation', 'ntaEntityData', 'ntaRounding', 'ntaSharedLogic', 'ntaSelectionTable', 'ntaMeldingen',
function ($log,   ntabuilding,   ntaValidation,   ntaEntityData,   ntaRounding,   ntaSharedLogic,   ntaSelectionTable,   ntaMeldingen) {
    'use strict';

    function VentilatieLogic(installId, ntaDependencyValidation) {
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        ///         INTERFACE              //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        const ventilatieLogic = this;

        ventilatieLogic.installId = installId;
        const _installationId = installId;

        /* Properties **********************************************************************************************/
        const _ventProperties = ntabuilding.properties['VENT'];
        const _ventAanvullendProperties = ntabuilding.properties['VENTAAN'];
        const _warmteterugwinningProperties = ntabuilding.properties['WARMTETERUG'];
        const _voorverwarmingProperties = ntabuilding.properties['VOORWARM'];
        const _ventilatorenProperties = ntabuilding.properties['VENTILATOR'];
        const _ventilatoreigenschappenProperties = ntabuilding.properties['VENTILATOREIG'];
        const _ventVerblijfgebiedProperties = ntabuilding.properties['VENT-VERB'];
        const _ventToevoerkanaalNaarWTWProperties = ntabuilding.properties['WARMTE-TOEV-KAN'];
        const _ventilatiedebietProperties = ntabuilding.properties['VENTDEB'];
        const _ventcapaciteitenProperties = ntabuilding.properties['VENTCAP'];
        const _ventzwembadruimteProperties = ntabuilding.properties['VENTZBR'];
        const _ventilatiedistributieProperties = ntabuilding.properties['VENTDIS'];

        /* data ****************************************************************************************************/
        let _ventDataId = 0;
        let _ventData;
        let _ventAanvullendData = [];
        let _warmteterugwinningData = [];
        let _voorverwarmingData = [];
        let _ventilatorenData = [];
        let _ventilatiedebietData = [];
        let _ventilatiedistributieData = [];

        let _warmteterugwinningAanvullendData = [];
        let _ventilatorenAanvullendData = [];

        if (_installationId) {
            _ventData = ntaEntityData.getFirstChild(_installationId, 'VENT');
            _ventDataId = _ventData.EntityDataId;

            _ventAanvullendData = ntaEntityData.getFirstChild(_ventData, 'VENTAAN');

            _warmteterugwinningData = ntaEntityData.getFirstChild(_ventData, 'WARMTETERUG');
            _warmteterugwinningAanvullendData = ntaEntityData.getFirstChild(_ventAanvullendData, 'WARMTETERUG');

            _voorverwarmingData = ntaEntityData.getFirstChild(_ventData, 'VOORWARM');

            _ventilatorenData = ntaEntityData.getFirstChild(_ventData, 'VENTILATOR');
            _ventilatorenAanvullendData = ntaEntityData.getFirstChild(_ventAanvullendData, 'VENTILATOR');

            _ventilatiedebietData = ntaEntityData.getFirstChild(_ventData, 'VENTDEB');

            _ventilatiedistributieData = ntaEntityData.getFirstChild(_ventData, 'VENTDIS');
        }

        const _units = getAangeslotenUnits();
        const _zbrRekenzones = ntaEntityData.getChildren(_ventData, 'RZ')
            .filter(rz => ntaEntityData.findEntities(rz, "UNIT-RZ.UNIT-RZ-GF").some(gf => gf.PropertyDatas['UNIT-RZ-GFID'].Value === 'GF_SPORT'));
        const _unitRekenzonesPerUnit = {};
        const _ventcapPerUnitRz = {};
        const _ventzbrPerRz = {};

        /* Tabellen **********************************************************************************************/
        const _warmteterugwinningTypes = createTable11_18();
        const _bypassTypes = createTableBypass();

        const _selectionTable = {
            VE: [],
            VE_AAN: [],
            ZRV: [],
            WTW: [],
        };

        const _productTypes = [
            { modelType: 'VE',     entityId: 'VENT',        productIdPropertyId: 'VENT_SYSVAR',    invoerPropertyId: 'VENT_INVOER',    valueSpecifiek: 'VENT_PROD', valueForfaitair: 'VENT_FORF' },
            { modelType: 'VE_AAN', entityId: 'VENTAAN',     productIdPropertyId: 'VENTAAN_SYSVAR', invoerPropertyId: 'VENTAAN_INVOER', valueSpecifiek: 'VENT_PROD', valueForfaitair: 'VENT_FORF' },
            { modelType: 'ZRV',    entityId: 'VOORWARM',    productIdPropertyId: 'VOORWARM_ROO',   invoerPropertyId: null,             valueSpecifiek: null,        valueForfaitair: null, },
            { modelType: 'WTW',    entityId: 'WARMTETERUG', productIdPropertyId: 'WARMTETERUG_TYPE_PRDT', invoerPropertyId: null,      valueSpecifiek: null,        valueForfaitair: null },
        ];
        _productTypes.forEach((pt, index, array) => array[pt.productIdPropertyId] = pt);

        const _ventilatieKolom = { isAanvullendSysteem: false, entityId: 'VENT', entdata: _ventData, voorverwarming: _voorverwarmingData, warmteterugwinning: _warmteterugwinningData, ventilatoren: _ventilatorenData };
        const _ventilatieAanvullendKolom = { isAanvullendSysteem: true, entityId: 'VENTAAN', entdata: _ventAanvullendData, voorverwarming: _voorverwarmingData, warmteterugwinning: _warmteterugwinningAanvullendData, ventilatoren: _ventilatorenAanvullendData };
        const _ventilatiekolommen = [_ventilatieKolom, _ventilatieAanvullendKolom];

        ventilatieLogic.ventData = _ventData;
        ventilatieLogic.ventAanvullendData = _ventAanvullendData;
        ventilatieLogic.warmteterugwinningData = _warmteterugwinningData;
        ventilatieLogic.voorverwarmingData = _voorverwarmingData;
        ventilatieLogic.ventilatorenData = _ventilatorenData;
        ventilatieLogic.ventilatiedebietData = _ventilatiedebietData;
        ventilatieLogic.ventilatiedistributieData = _ventilatiedistributieData;
        ventilatieLogic.zbrRekenzones = _zbrRekenzones;
        ventilatieLogic.units = _units;
        ventilatieLogic.warmteterugwinningaanvullendData = _warmteterugwinningAanvullendData;
        ventilatieLogic.ventilatorenaanvullendData = _ventilatorenAanvullendData;

        ventilatieLogic.ventilatiekolommen = _ventilatiekolommen;

        ventilatieLogic.propertyHeaderIsHidden = propertyHeaderIsHidden;
        ventilatieLogic.distributieIsHidden = distributieIsHidden;
        ventilatieLogic.voorverwarmingIsHidden = voorverwarmingIsHidden;
        ventilatieLogic.ventilatiedebietenIsHidden = ventilatiedebietenIsHidden;
        ventilatieLogic.ventilatorEigenschappenUnitIsHidden = ventilatorEigenschappenUnitIsHidden;
        ventilatieLogic.ventilatorEigenschappenIsHidden = ventilatorEigenschappenIsHidden;
        ventilatieLogic.ventilatorenIsHidden = ventilatorenIsHidden;
        ventilatieLogic.warmteterugwinningIsHidden = warmteterugwinningIsHidden;
        ventilatieLogic.toevoerkanaalTabelIsHidden = toevoerkanaalTabelIsHidden;
        ventilatieLogic.verblijfsgebiedTabelIsHidden = verblijfsgebiedTabelIsHidden;
        ventilatieLogic.kolomIsHidden = kolomIsHidden;
        ventilatieLogic.isLbkAanwezig = isLbkAanwezig;

        ventilatieLogic.ventProperties = _ventProperties;
        ventilatieLogic.ventaanvullendProperties = _ventAanvullendProperties;
        ventilatieLogic.warmteterugwinningProperties = _warmteterugwinningProperties;
        ventilatieLogic.voorverwarmingProperties = _voorverwarmingProperties;
        ventilatieLogic.ventilatorenProperties = _ventilatorenProperties;
        ventilatieLogic.ventilatoreigenschappenProperties = _ventilatoreigenschappenProperties;
        ventilatieLogic.ventVerblijfgebiedProperties = _ventVerblijfgebiedProperties;
        ventilatieLogic.ventToevoerkanaalNaarWTWProperties = _ventToevoerkanaalNaarWTWProperties;
        ventilatieLogic.ventilatiedebietProperties = _ventilatiedebietProperties;
        ventilatieLogic.ventcapaciteitenProperties = _ventcapaciteitenProperties;
        ventilatieLogic.ventzwembadruimteProperties = _ventzwembadruimteProperties;
        ventilatieLogic.ventilatiedistributieProperties = _ventilatiedistributieProperties;

        ventilatieLogic.getUnitRekenzones = getUnitRekenzones;
        ventilatieLogic.getVentilatiecapaciteit = getVentilatiecapaciteit;
        ventilatieLogic.getVentilatiezwembadruimte = getVentilatiezwembadruimte;
        ventilatieLogic.setVentilatorenEigenschappenPerUnit = setVentilatorenEigenschappenPerUnit;

        ventilatieLogic.isHidden = isHidden;
        ventilatieLogic.isReadOnly = isReadOnly;

        ventilatieLogic.validate = validate;
        ventilatieLogic.validateDependencies = validateDependencies;

        ventilatieLogic.startFormValidation = startFormValidation;
        ventilatieLogic.endFormValidation = endFormValidation;

        ventilatieLogic.saveValue = saveValue;
        ventilatieLogic.getCodedValues = getCodedValues;

        ventilatieLogic.getListItem = getListItem;
        ventilatieLogic.getSelectionTable = getSelectionTable;
        ventilatieLogic.saveValueSelectionTable = saveValueSelectionTable;
        ventilatieLogic.setSelectedItemSelectionTable = setSelectedItemSelectionTable;
        ventilatieLogic.dependencyValidator = ntaDependencyValidation;

        ventilatieLogic.getProductInfo = propId => _productTypes[propId];


        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        ///         INITALIZIATION         //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        buildVentcapaciteitenTabel();
        if (ntabuilding.ntaVersionId >= 200) {
            buildVentZwembadruimteTabel();
        }

        setVerblijfsgebiedVentPerUnit(_ventData);
        setVerblijfsgebiedVentPerUnit(_ventAanvullendData);
        setToevoerkanaalNaarWTWLengtePerUnit(_warmteterugwinningData);
        setToevoerkanaalNaarWTWLengtePerUnit(_warmteterugwinningAanvullendData);

        setDefaultValueInvoerVentilatiesysteem();

        setVentilatorenEigenschappenPerUnit(_ventilatorenData);
        setVentilatorenEigenschappenPerUnit(_ventilatorenAanvullendData);

        setDefaultValueFabricagejaar();

        //-- eerst bovenstaande defaults zetten voordat de selectietabel geladen wordt. Laden gebruikt bij checken bovenstaande zaken. Deze volgorde is dus belangrijk
        loadProductsFromServer();

        checkUnits();

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        ///         IMPLEMENTATION         //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        function getMatchingProduct(kolom, matches = product => false) {
            const propIdSysVar = kolom.isAanvullendSysteem ? 'VENTAAN_SYSVAR' : 'VENT_SYSVAR'; // V12 of V06
            const products = [
                getSelectedProduct(propIdSysVar, kolom.entdata),
                getSelectedProduct('WARMTETERUG_TYPE_PRDT', kolom.warmteterugwinning), // V96
            ];
            return products.find(p => p && matches(p));
        } //-- end: getMatchingProduct ----------------------------------------------------------//

        function getSelectedProduct(propOrId, entdata) {
            const prop = typeof propOrId === 'string' ? ntabuilding.properties[propOrId] : propOrId;
            if (!prop) return null;

            const propdata = prop.getData(entdata);
            if (!propdata || !propdata.Visible) return null;

            const systeemId = parseInt(propdata.Value);
            if (!systeemId) return null;

            const producttype = _productTypes[prop.Id];
            const table = producttype && _selectionTable[producttype.modelType];
            const product = table?.find(p => p.Id === systeemId);
            return product;
        } //-- end: getSelectedProduct ----------------------------------------------------------//

        function getListItem(propOrId, entdata, list = null) {
            const prop = typeof propOrId === 'string' ? ntabuilding.properties[propOrId] : propOrId;

            let listItem = null;

            if (prop?.Domain?.DomainType > 1 && entdata) {
                let itemList;
                let itemId;

                const propData = entdata.PropertyDatas[prop.Id];
                if (_productTypes[prop.Id]) {
                    // selectie tabel value
                    itemId = parseInt(propData.Value);
                    itemList = entdata.filteredItems;
                } else {
                    // gewone coded value
                    itemId = propData.Value;
                    // als geen gefilterde getCodedValue list is meegegeven, ongefilterde codedValue list gebruiken
                    itemList = list ?? prop.Domain.Codes;
                }

                if (propData.Value && itemList?.length) {
                    listItem = itemList.find(x => x.Id === itemId);
                }
            }
            return listItem;
        } //-- end: getListItem ------------------------------------------------------------------------//

        function setSelectedItemSelectionTable(prop, entdata, selectedItem = null) {
            // dit moet alleen voor velden van het domain type 4 of 5.
            if (prop.Domain.DomainType === 4 || prop.Domain.DomainType === 5) {
                if (!selectedItem) {
                    selectedItem = getListItem(prop, entdata);
                }

                if (_productTypes[prop.Id]) {
                    if (selectedItem) {
                        entdata.selectedItem = selectedItem;
                        entdata.searchText = selectedItem.Value;
                    } else {
                        entdata.selectedItem = null;
                        entdata.searchText = "";
                    }
                }
            }
        } //-- end: setSelectedItemSelectionTable -----------------------------------------------//

        function loadProductsFromServer() {
            _selectionTable.VE = ntaSelectionTable.getProducts('VE', ntaSharedLogic.isUtiliteit());
            if (ntabuilding.appVersionId < 3) { // vóór versie 3.1 moeten we fregfan_v1 gebruiken
                _selectionTable.VE = _selectionTable.VE.map(product => {
                    const newProduct = Object.assign({}, product); // maak een kopie van elk product
                    newProduct.fregfan = newProduct.fregfan_v1; // vervang fregfan door fregfan_v1 (die voor versie 3.0)
                    delete newProduct.fregfan_v1; // die hebben we niet meer nodig
                    return newProduct;
                });
            }

            //-- producten voor aanvullende systemen zijn gelijk aan de gewone systemen
            _selectionTable.VE_AAN = _selectionTable.VE;

            //-- voorverwarming heeft eigen producten
            _selectionTable.ZRV = ntaSelectionTable.getProducts('ZRV', ntaSharedLogic.isUtiliteit());

            //-- V96 toon de rijen uit de selectietabel waar certificate = P EN waar de waarde in kolom 'variant' op VE_model = D.2
            _selectionTable.WTW = _selectionTable.VE.filter(p => p.Certificate && p.Variant === 'D.2');

            const modelTypeEntdatas = {
                VE:     [_ventData],
                VE_AAN: [_ventAanvullendData],
                ZRV:    [_voorverwarmingData],
                WTW:    [_warmteterugwinningData, _warmteterugwinningAanvullendData],
            };
            for (const productTypeInfo of _productTypes) {
                const prop = ntabuilding.properties[productTypeInfo.productIdPropertyId];
                if (prop) {
                    const entdatas = modelTypeEntdatas[productTypeInfo.modelType];
                    for (const entdata of entdatas) {
                        getSelectionTable(prop, entdata);
                        setSelectedItemSelectionTable(prop, entdata);
                    }
                }
            }

            setValuesDependingOnSelectionTable();
        } //-- end: loadProductsFromServer ------------------------------------------------------//

        function getSelectionTable(prop, entdata, searchText = "") {
            const productTypeInfo = _productTypes[prop.Id];
            const table = _selectionTable[productTypeInfo.modelType];
            if (!table || prop.Domain.DomainType !== 4) //selection table value
                return [];

            let res = table;

            // [SE] Eerst filteren op productspecifiek/forfaitair, indien relevant
            if (productTypeInfo.invoerPropertyId) {
                const propInvoer = ntabuilding.properties[productTypeInfo.invoerPropertyId];
                const invoerValue = propInvoer.getValue(entdata);
                if (invoerValue === productTypeInfo.valueSpecifiek) {
                    res = res.filter(p => p.Certificate === 1);
                } else {
                    //--bij VE/VE_AAN moet de forfaitaire producten ook mee bij eigen waarden
                    res = res.filter(p => p.Certificate === 0);
                }
            }

            // Als bij Settings is aangevinkt dat alleen de actuele verklaringen gekozen mogen,
            //  moeten de verlopen verklaringen er uit gefilterd worden.
            if (ntaSharedLogic.showOnlyValidProducts()) {
                res = res.filter(p => !p.ExpiryDate || Date.parse(p.ExpiryDate) > Date.now());
            }

            switch (productTypeInfo.modelType) {
                case 'VE':
                case 'VE_AAN': {
                    const [propIdSystem, propIdZRRoosters, propIdZRRType] = productTypeInfo.modelType === 'VE'
                        ? ['VENT_SYS',    'VENT_ZRR',    'VENT_ZRR_TYPE']
                        : ['VENTAAN_SYS', 'VENTAAN_ZRR', 'VENTAAN_ZRR_TYPE'];

                    // [SL] nu moet ik nog filteren op gekozen systeem A, B, C, D of E
                    const ventilatiesystemen = {
                        VENTSYS_NAT: 'A',
                        VENTSYS_MECH: 'B',
                        VENTSYS_NATMECH: 'C',
                        VENTSYS_MECHC: 'Dc',
                        VENTSYS_MECHD: 'Dd',
                        VENTSYS_GEC: 'E',
                    };
                    const propValueSys = entdata.PropertyDatas[propIdSystem].Value;
                    const ventilatiesysteem = ventilatiesystemen[propValueSys];
                    res = res.filter(p => p.Systeem === ventilatiesysteem);

                    // [SE] nu moet ik nog filteren op GG of NGG
                    const woningtype = ntaSharedLogic.isNietGrondGebonden() ? "NGG" : "GG";
                    res = res.filter(p => !p.Woningtype || p.Woningtype === woningtype);

                    // [SE] als versie ge3-4 filter op kolom ZR-rooster afhankelijk van de keuzes in V91 en V92 / V93 en V94 (zie 'koppelingstabel ZR roosters.xlsx)
                    const propdataZRRooster = entdata.PropertyDatas[propIdZRRoosters];
                    if (propdataZRRooster) {
                        let zrRoostertype = '';
                        if (propdataZRRooster.Value === 'VENT_ZRR_WEL') {
                            const roosterTypes = {
                                VENT_ZRR_TYPE_1: '1Pa',
                                VENT_ZRR_TYPE_1_5: '1-5Pa',
                                VENT_ZRR_TYPE_5_10: '5-10Pa',
                                VENT_ZRR_TYPE_NA_2003: '1Pa',
                                VENT_ZRR_TYPE_TM_2003: '5-10Pa',
                            };
                            const zrrType = entdata.PropertyDatas[propIdZRRType].Value;
                            zrRoostertype = roosterTypes[zrrType];

                        } else if (propdataZRRooster.Value === 'VENT_ZRR_NA_2012') {
                            zrRoostertype = '1Pa';
                        }
                        res = res.filter(p => !p.ZR_rooster || p.ZR_rooster === zrRoostertype);
                    }

                    break;
                }
            }

            res.Singleresult = res.length === 1;

            // Tot slot filteren op de zoektekst
            if (searchText && searchText.length > 0) {
                searchText = searchText.toLowerCase();
                res = res.filter(p => p.Value && p.Value.toLowerCase().includes(searchText));
            }

            entdata.filteredItems = res;
            ntaSharedLogic.checkPropdataInList(prop, entdata, res, ventilatieLogic);
            return res;
        } //-- end: getSelectionTable -----------------------------------------------------------//

        function setValuesDependingOnSelectionTable() {

            for (const kolom of _ventilatiekolommen) {
                const [modelType, propIdSysVar,    propIdInvoer,     propIdFCtrl,     propIdVariant] = kolom.isAanvullendSysteem
                    ? ['VE_AAN', 'VENTAAN_SYSVAR', 'VENTAAN_INVOER', 'VENTAAN_FCTRL', 'VENTAAN_VARIANT']
                    : ['VE',     'VENT_SYSVAR',    'VENT_INVOER',    'VENT_FCTRL',    'VENT_VARIANT'];

                //-- ff niks doen als er geen selectietabel is of er geen rijen in de selectietabel zijn
                if (!_selectionTable[modelType]?.length)
                    continue;

                //-- alleen als kolom 1 een E-systeem is, is de aanvullende data relevant.
                if (kolom.isAanvullendSysteem && _ventData.PropertyDatas['VENT_SYS'].Value !== 'VENTSYS_GEC') // V03
                    continue;

                const sysVarProduct = getSelectedProduct(propIdSysVar, kolom.entdata); // V06 of V12

                const invoer = kolom.entdata.PropertyDatas[propIdInvoer].Value; // V05 of V11
                if (invoer !== 'VENT_EIG') {
                    if (!isHidden(propIdFCtrl, kolom.entdata)) {
                        ntaSharedLogic.saveProductValueToPropData(ventilatieLogic, sysVarProduct, 'fCtrl', kolom.entdata, propIdFCtrl);
                    }
                }

                const wtwProduct = getSelectedProduct('WARMTETERUG_TYPE_PRDT', kolom.warmteterugwinning); // V96

                // gebruik het eerste product uit de selectietabel (van V06 of V12, of V96) dat Pnom-waardes heeft
                const ventilatorenProduct = [sysVarProduct, wtwProduct].find(p => p && (p.Pnom1 !== null || p.Pnom2 !== null || p.Pnom3 !== null));
                const propIdsFromProductPropNames = [
                    ['VENTILATOR_FREGB', 'fregfan'],
                    ['VENTILATOR_PNOM1', 'Pnom1'],
                    ['VENTILATOR_PNOM2', 'Pnom2'],
                    ['VENTILATOR_PNOM3', 'Pnom3'],
                ];
                for (const [propId, propName] of propIdsFromProductPropNames) {
                    if (isRelevant(propId, kolom.ventilatoren)) {
                        ntaSharedLogic.saveProductValueToPropData(ventilatieLogic, ventilatorenProduct, propName, kolom.ventilatoren, propId);
                    }
                }
                ntaSharedLogic.saveProductValueToPropData(ventilatieLogic, sysVarProduct, 'Variant', kolom.entdata, propIdVariant, (value, prop) => {
                    return prop.Domain.Codes.find(cv => cv.Value === value.trim())?.Id || value;
                });

                // gebruik het eerste product uit de selectietabel (van V06 of V12, of V96) dat een waarde heeft voor eta_hr
                const product = [sysVarProduct, wtwProduct].find(p => p && p.eta_hr !== null);
                if (product?.Certificate) { // productspecifiek
                    const propWTWType = _warmteterugwinningProperties['WARMTETERUG_TYPE']; // V23
                    if (!isHidden(propWTWType, kolom.warmteterugwinning)) {
                        const wtwType = propWTWType.getValue(kolom.warmteterugwinning);
                        const newWTWType = wtwType === 'WARMTETYPE_GEEN' ? 'WARMTETYPE_REN1' : wtwType;
                        saveValue(propWTWType, kolom.warmteterugwinning, newWTWType);
                    }

                    const propWTWeta = _warmteterugwinningProperties['WARMTETERUG_REND'];
                    if (!isHidden(propWTWeta, kolom.warmteterugwinning)) {
                        ntaSharedLogic.saveProductValueToPropData(ventilatieLogic, product, 'eta_hr', kolom.warmteterugwinning, propWTWeta);
                    }
                    const propBypassA = _warmteterugwinningProperties['WAMRTETERUG_BYPA'];
                    if (!isHidden(propBypassA, kolom.warmteterugwinning)) {
                        ntaSharedLogic.saveProductValueToPropData(ventilatieLogic, product, 'eta_bypass', kolom.warmteterugwinning, propBypassA);
                        //-- als waarde uit selectietabel voor eta_bypass gezet wordt, moet de waarde voor bypass op Eigen Waarde gezet worden.
                        //-- ook de wijze van bypass moet gezet worden naar eigen waarde, zodat de juiste bypass mee gaat naar de rekenkern
                        //-- dit doen we alleen voor de 3.1+ projecten. De 3.0 projecten houden de verkeerde resultaten
                        if (ntabuilding.appVersionId >= 100) {
                            saveValue('WARMTETERUG_BYP', kolom.warmteterugwinning, 'WERMTEBYP_EIG');
                        }
                    }
                }
            }

            if (_selectionTable.ZRV?.length) {
                const toevoer = _voorverwarmingData.PropertyDatas['VOORWARM_NT'].Value;
                if (toevoer === 'VOORWARMNT_PROD') {
                    const product = getListItem('VOORWARM_ROO', _voorverwarmingData);

                    const propIdsFromProductPropNames = [
                        ['VOORWARM_MAXV', 'PelvvMax'],
                        ['VOORWARM_MAXT', 'deltaTprehRoostersMax'],
                        ['VOORWARM_BUIT', 'Taan'],
                        ['VOORWARM_MAXI', 'TsuplElvvMax'],
                    ];
                    for (const [propId, propName] of propIdsFromProductPropNames) {
                        if (!isHidden(propId, _voorverwarmingData)) {
                            ntaSharedLogic.saveProductValueToPropData(ventilatieLogic, product, propName, _voorverwarmingData, propId);
                        }
                    }
                }
            }
        } //-- end: setValuesDependingOnSelectionTable ------------------------------------------//

        function validate(prop, propdata, entdata) {
            if (!ntabuilding.canSave()) return;

            if (typeof prop === 'string') {
                prop = ntabuilding.properties[prop];
                if (!propdata && entdata) propdata = prop.getData(entdata);
            }
            if (!prop || !propdata || propdata.BuildingId !== ntabuilding.buildingId) {
                return;
            }

            let hidden = isHidden(prop, entdata);
            let readonly = isReadOnly(prop, entdata);
            let valid = ntaValidation.IsValid(ventilatieLogic.form_installationventilatie, prop, propdata, hidden, readonly);

            switch (prop.Id) {
                case "VENT_SYSVAR":
                case "VENTAAN_SYSVAR": {
                    const [propSysId, propInvoerId] = prop.Id === 'VENT_SYSVAR'
                        ? ['VENT_SYS', 'VENT_INVOER']
                        : ['VENTAAN_SYS', 'VENTAAN_INVOER'];
                    const ventilatiesysteem = entdata.PropertyDatas[propSysId].Value;
                    const invoer = entdata.PropertyDatas[propInvoerId].Value;

                    valid = true;

                    if (ventilatiesysteem && invoer === 'VENT_PROD') {
                        const producten = entdata.filteredItems;

                        if (producten && producten.length <= 0) { // Toon E013
                            valid = false;
                        }
                    }

                    ntaSharedLogic.setMelding("[E013]", propdata, ventilatieLogic.form_installationventilatie, valid)

                    break;
                }
                case "VENT_PKOEL": {
                    getCodedValues(prop, entdata); // update van de lijst mogelijke keuzes. dit is afhankelijk van conditie [RI]
                    break;
                }
                case "WARMTETERUG_SYS": {
                    const ventilatiekolom = _ventilatiekolommen.find(kolom => kolom.warmteterugwinning.EntityDataId === entdata.EntityDataId);
                    if (ventilatiekolom) {
                        saveValue(prop, entdata, bepaalWtwSysteem(ventilatiekolom));
                    }
                    break;
                }
            }


            return valid;
        } //-- end: validate ------------------------------------------------------------------------//

        function saveValue(prop, entdata, newValue) {
            return ntaSharedLogic.saveValue(prop, entdata, newValue, ventilatieLogic);
        } //-- end: saveValue ------------------------------------------------------------------------//

        function saveValueSelectionTable(prop, item, entdata) {
            ntaSharedLogic.saveValueSelectionTable(prop, item, entdata, ventilatieLogic);
        } //-- end: saveValueSelectionTable ------------------------------------------------------------------------//

        function setDescriptionInstallation(entdata) {
            //-- ik moet eerst weten of het hier om de gewone ventData gaat en niet de aanvullende
            if (entdata.EntityId === 'VENT') {
                const propdataInstallDescr = ntaEntityData.get(_installationId).PropertyDatas['INSTALL_OMSCHR'];
                if (propdataInstallDescr) {
                    const product = getSelectedProduct('VENT_SYSVAR', entdata);
                    ntaEntityData.saveprop(propdataInstallDescr, product?.Value || '');
                }
            }
        } //-- end: setDescriptionInstallation ------------------------------------------------------------------------//

        function propertyHeaderIsHidden(prop, entdata) {
            if (!prop || !entdata) {
                return;
            }

            let showIt = true;
            switch (prop.Id) {
                case 'VENTILATOREIG_DEB': // V40
                    {
                    showIt = conditieRD(entdata);
                    break;
                    }
                case 'VENTILATOREIG_JAAR': // V42
                    {
                        // Conditie FH
                        showIt = conditieFH(entdata) && ntaSharedLogic.getBouwjaar() < 2005;
                        break;
                    }
                case 'VENTILATOREIG_U': // V43
                case 'VENTILATOREIG_I': // V44
                case 'VENTILATOREIG_E': // V45
                    {
                        const invoerVentilatorVermogen = entdata.PropertyDatas['VENTILATOR_INV'].Value;
                        showIt = invoerVentilatorVermogen === 'VENTILATORFABR_E'
                        break;
                    }
                case 'VENTILATOREIG_PAS': // V46
                case 'VENTILATOREIG_PNA': // V47
                    {
                        const invoerVentilatorVermogen = entdata.PropertyDatas['VENTILATOR_INV'].Value;
                        showIt = invoerVentilatorVermogen === 'VENTILATORFABR_D' || invoerVentilatorVermogen === 'VENTILATORFABR_E';

                        if (prop.Id === 'VENTILATOREIG_PNA') { // V47
                            showIt = showIt && conditieMW_A();
                        }

                        break;
                    }
                case 'VENTILATOREIG_PNB': // V48
                    {
                        const invoerVentilatorVermogen = entdata.PropertyDatas['VENTILATOR_INV'].Value;
                        showIt = invoerVentilatorVermogen === 'VENTILATORFABR_B' || invoerVentilatorVermogen === 'VENTILATORFABR_C';
                        break;
                    }
                case 'VENTILATOREIG_FREG': {
                    showIt = true; //-- property is altijd zichtbaar. Hier alleen uitzoeken of hij relevant is of niet.

                    const invoerVentilatorVermogen = entdata.PropertyDatas['VENTILATOR_INV'].Value;
                    const relevant = invoerVentilatorVermogen === 'VENTILATORFABR_C';

                    //[MW-C] verberg veld als formulier wordt gebruikt bij HVAC maatregel EN waarde uit rekenkern komt (kan ook eigen invoer zijn)
                    if (!relevant) { // is nominaal ventilator vermogen - fregfan eigen waarde (VENTILATORFABR_C)
                        showIt = showIt && conditieMW_A();
                    }

                    break;
                }
                default:
            }

            return !showIt;
        } //-- end: propertyHeaderIsHidden ------------------------------------------------------------------------//

        function isRelevant(propOrId, entdata) {
            const prop = typeof propOrId === 'string' ? ntabuilding.properties[propOrId] : propOrId;
            isHidden(prop, entdata); // zorg dat de relevantie goed gezet is
            return prop.getData(entdata)?.Relevant;
        } //-- end: isRelevant --------------------------------------------------------------------

        function isHidden(propOrId, entdata) {
            const prop = typeof propOrId === 'string' ? ntabuilding.properties[propOrId] : propOrId;
            if (!prop || !entdata || entdata.BuildingId !== ntabuilding.buildingId) {
                return true;
            }

            const propdata = entdata.PropertyDatas[prop.Id];

            let showit = true;
            let relevant = null;

            switch (prop.Id) {
                case 'VENT_OPEN': {
                    showit = false;
                    break;
                }
                case 'VENT_ZRR': { // V91
                    // [SAI] toon als V03 = A. natuurlijke toe- en afvoer / C. natuurlijke toevoer en mechanische afvoer
                    showit = ['VENTSYS_NAT', 'VENTSYS_NATMECH'].includes(entdata.PropertyDatas['VENT_SYS'].Value);
                    break;
                }
                case 'VENT_ZRR_TYPE': { // V92
                    // [SAJ] toon als V91 = ZR roosters aanwezig
                    const propdataZRroosters = entdata.PropertyDatas['VENT_ZRR'];
                    showit = propdataZRroosters.Visible && propdataZRroosters.Value === 'VENT_ZRR_WEL';
                    break;
                }
                case 'WARMTETERUG_FABR':// V27
                    if (!ntaSharedLogic.isUtiliteit()) {
                        // Conditie WF
                        let propBypass = _warmteterugwinningProperties['WARMTETERUG_BYP'];
                        let propValueBypass = propBypass.getValue(entdata);

                        let sitA = !isHidden(propBypass, entdata) && (propValueBypass === 'WARMTEBYP_BEK' || propValueBypass === 'WARMTEBYP_ONB');
                        let sitB = ntaSharedLogic.getBouwjaar() < 2010;

                        showit = sitA && sitB;

                        if (!showit && sitA) {
                            /* Als V26='bypass bekend - bypassaandeel onbekend' of 'bypass onbekend' (ID 3 en 4 in table-bypass) AND G06≥2010 dan gebruik waarde ' fabricagejaar 2010 en nieuwer' en verberg veld*/
                            let newFabrJaar = 'WARMTEFABR_NIEUW';
                            relevant = true;
                            saveValue(prop, entdata, newFabrJaar);
                        }
                    } else {
                        showit = false;
                    }
                    break;
                case 'VENT_VERB':  // V04
                case 'VENTAAN_VERB': { // V10
                    // conditie [SB] en [SW]
                    showit = conditieSB() && conditieSW();
                    break;
                }
                case 'VENT_VARIANT': // V07
                    {
                        // conditie ST
                        let invoerVentilatiesysteem = _ventData.PropertyDatas['VENT_INVOER'].Value;

                        showit = invoerVentilatiesysteem === 'VENT_PROD';
                        relevant = true;

                        break;
                    }
                case 'VENT_GEM': { // V83 <-- VENT_GEM is property voor gemeenschappelijke of niet-gemeenschappelijke installatie (is identiek aan VENT_LBK, alleen de teksten zijn anders)
                    // Condities [SY] en [SAB]
                    const ventilatiesysteemtype = entdata.PropertyDatas['VENT_SYS'].Value;
                    // Vóór NTAVersionId 34 bestond VENT_LBK niet, en moest VENT_GEM altijd weergegeven worden.
                    showit = conditieSY(entdata) && (ntabuilding.ntaVersionId < 34 || ventilatiesysteemtype === 'VENTSYS_NATMECH');
                    break;
                }
                case 'VENT_LBK': { // V83 <-- VENT_LBK is property voor luchtbehandelingskast aanwezig wel of niet (is identiek aan VENT_GEM, alleen de teksten zijn anders)
                    // Condities [SY] en [SAB]
                    const ventilatiesysteemtype = entdata.PropertyDatas['VENT_SYS'].Value;
                    showit = conditieSY(entdata) && ventilatiesysteemtype !== 'VENTSYS_NATMECH';
                    break;
                }
                case 'VENT_OPP_GEM': { // V84
                    // Condities [SAE] en [SAF] toon veld als V83='gemeenschappelijke installatie' of 'luchtbehandelingskast aanwezig'  EN G04='appartement (voor bestaande bouw)' OF 'unit in utiliteitsgebouw (voor bestaande bouw)'
                    showit = !isHidden('VENT_GEM', entdata) && isLbkAanwezig() && ntaSharedLogic.isAppartementOfUtiliteitVoorBestaandeBouw();
                    break;
                }
                case 'VENT_OPP_LBK': { // V84
                    // Condities [SAE] en [SAF] toon veld als V83='gemeenschappelijke installatie' of 'luchtbehandelingskast aanwezig'  EN G04='appartement (voor bestaande bouw)' OF 'unit in utiliteitsgebouw (voor bestaande bouw)'
                    showit = !isHidden('VENT_LBK', entdata) && isLbkAanwezig() && ntaSharedLogic.isAppartementOfUtiliteitVoorBestaandeBouw();
                    break;
                }
                case 'VENT_PKOEL': {    // V72
                    // conditie [SAH] verberg als V03 = 'A. natuurlijke toe- en afvoer'
                    showit = _ventData.PropertyDatas['VENT_SYS'].Value !== 'VENTSYS_NAT';
                    break;
                }
                case 'VENTAAN_VARIANT':  // V13
                    {
                        let invoerVentilatiesysteem = _ventAanvullendData.PropertyDatas['VENTAAN_INVOER'].Value;

                        showit = invoerVentilatiesysteem === 'VENT_PROD';
                        relevant = true;

                        break;
                    }
                case 'VENT_SYSVAR':  // V06
                    {
                        //let invoerVentilatiesysteem = _ventData.PropertyDatas['VENT_INVOER'].Value;

                        //showit = invoerVentilatiesysteem !== 'VENT_EIG';
                        showit = true; //-- altijd zichtbaar ook bij eigen waarden. Dan moet er sowieso een variant keuze gemaakt worden obv forfaitaire producten ivm wtw
                        break;
                    }
                case 'VENT_QV_ODA_REQ': {
                    showit = false;
                    relevant = true;
                    break;
                }
                case 'VENT-VERB_OMSCHR':// V77
                    {
                        relevant = false;
                        break;
                    }
                case 'VENTAAN_SYSVAR': // V12
                    {
                        //let invoerVentilatiesysteem = _ventAanvullendData.PropertyDatas['VENTAAN_INVOER'].Value;

                        //showit = invoerVentilatiesysteem !== 'VENT_EIG';
                        showit = true;
                        break;
                    }
                case 'VENTAAN_ZRR': { // V93
                    // [SAL] toon als V09 = A. natuurlijke toe- en afvoer / C. natuurlijke toevoer en mechanische afvoer
                    showit = ['VENTSYS_NAT', 'VENTSYS_NATMECH'].includes(entdata.PropertyDatas['VENTAAN_SYS'].Value);
                    break;
                }
                case 'VENTAAN_ZRR_TYPE': { // V94
                    // [SAM] toon als V93 = ZR roosters aanwezig
                    const propdataZRroosters = entdata.PropertyDatas['VENTAAN_ZRR'];
                    showit = propdataZRroosters.Visible && propdataZRroosters.Value === 'VENT_ZRR_WEL';
                    break;
                }
                case 'VOORWARM_NT': // V15
                    {
                        let hidden = voorverwarmingIsHidden(_ventilatieKolom) && voorverwarmingIsHidden(_ventilatieAanvullendKolom);
                        showit = !hidden;
                        break;
                    }
                case 'VOORWARM_ROO': // V16
                    {
                        const propNatuurlijkeToevoer = _voorverwarmingProperties['VOORWARM_NT'];
                        const propValueNatuurlijkeToevoer = propNatuurlijkeToevoer.getValue(_voorverwarmingData);

                        showit = !isHidden(propNatuurlijkeToevoer, entdata) && propValueNatuurlijkeToevoer === 'VOORWARMNT_PROD'
                        break;
                    }
                case 'VOORWARM_AAN': // V17
                    {
                        let natuurlijkeToevoer = _voorverwarmingData.PropertyDatas['VOORWARM_NT'].Value;

                        showit = !!natuurlijkeToevoer && natuurlijkeToevoer !== 'VOORWARMNT_GEEN'; // Conditie VC
                        break;
                    }
                case 'VOORWARM_MAXV':
                case 'VOORWARM_MAXT':
                case 'VOORWARM_MAXI':
                case 'VOORWARM_BUIT':
                    {
                        let natuurlijkeToevoer = _voorverwarmingData.PropertyDatas['VOORWARM_NT'].Value;
                        showit = natuurlijkeToevoer === 'VOORWARMNT_PROD' || natuurlijkeToevoer === 'VOORWARMNT_EIG';
                        break;
                    }
                case 'WARMTETERUG_INV': { // V95
                    const ventilatiekolom = _ventilatiekolommen.find(vk => vk.warmteterugwinning.EntityDataId === entdata.EntityDataId);
                    if (ventilatiekolom) {
                        showit = !warmteterugwinningIsHidden(ventilatiekolom) && conditieWQ(ventilatiekolom);
                    }
                    break;
                }
                case 'WARMTETERUG_TYPE': // V23
                    {
                        const ventilatiekolom = _ventilatiekolommen.find(vk => vk.warmteterugwinning.EntityDataId === entdata.EntityDataId);
                        if (ventilatiekolom) {
                            showit = !warmteterugwinningIsHidden(ventilatiekolom) && conditieWB(ventilatiekolom);
                        }

                        // Vanaf de release van v3.4 is het type alleen relevant als het ook zichtbaar is.
                        if (!ntabuilding.properties['WARMTETERUG_INV']) {
                            relevant = true;
                        }
                        break;
                    }
                case 'WARMTETERUG_TYPE_PRDT': { // V96
                    showit = conditieWR(entdata);
                    break;
                }
                case 'WARMTETERUG_DISS': //-- V25
                    {
                        // Conditie [WD]
                        const propWtwInvoer = ntabuilding.properties['WARMTETERUG_INV']; // V95
                        if (propWtwInvoer) {
                            const propdataWtwInvoer = propWtwInvoer.getData(entdata);
                            showit = propdataWtwInvoer.Visible && propdataWtwInvoer.Value === 'WTWINV_REN2';
                        } else {
                            const propWarmteterugwinningType = _warmteterugwinningProperties['WARMTETERUG_TYPE'];
                            const propValueWarmteterwinningType = propWarmteterugwinningType.getValue(entdata);
                            showit = !isHidden(propWarmteterugwinningType, entdata) && propValueWarmteterwinningType === 'WARMTETYPE_REN2';
                        }
                        break;
                    }
                case 'WARMTETERUG_BYP': //-- V26
                    {
                        const ventilatiekolom = _ventilatiekolommen.find(vk => vk.warmteterugwinning.EntityDataId === entdata.EntityDataId);
                        if (ventilatiekolom) {
                            showit = conditieWN(entdata, ventilatiekolom);

                            // property kan ook relevant zijn als hij hidden is, zoals bijv. bij productspecifiek. Dit geldt alleen voor de 3.1 projecten.
                            // Dit zat al jaren fout en daarom laten we de resultaten voor de 3.0 project zoals ze waren en mag dit voor die projecten
                            // niet aangepast worden.
                            if (ntabuilding.appVersionId >= 100) {
                                relevant = !warmteterugwinningIsHidden(ventilatiekolom);
                            }
                        }

                        break;
                    }
                case 'WAMRTETERUG_BYPA': //-- V28
                    // Conditie WH
                    showit = conditieWH(entdata);
                    break;
                case 'WARMTETERUG_WTW': //-- V85
                    {
                        // Conditie [WO]
                        const propBypassAandeel = ntabuilding.properties['WAMRTETERUG_BYPA']; // V28
                        const bypassAandeel = ntaSharedLogic.parseFloat(propBypassAandeel.getValue(entdata), 0);

                        const ventilatiekolom = _ventilatiekolommen.find(vk => vk.warmteterugwinning.EntityDataId === entdata.EntityDataId);
                        const invoerVent = ventilatiekolom.entityId === "VENT"
                            ? ventilatiekolom.entdata.PropertyDatas['VENT_INVOER'].Value        // V05
                            : ventilatiekolom.entdata.PropertyDatas['VENTAAN_INVOER'].Value;    // V11

                        const propInvoerWtw = ntabuilding.properties['WARMTETERUG_INV'];        // V95
                        const invoerWtw = propInvoerWtw?.getValue(entdata);

                        showit = bypassAandeel === 1
                            && !isHidden(propBypassAandeel, entdata)
                            && (invoerVent === 'VENT_PROD'
                                || ['WTWINV_PROD', 'WTWINV_REN1', 'WTWINV_REN2', 'WTWINV_REN3'].includes(invoerWtw)
                                    && !isHidden(propInvoerWtw, entdata));

                        //-- als veld verborgen is "geen koudeterugwinning via WTW" doorgeven voor VERW-OPWEK_GEM
                        if (!showit) {
                            saveValue(prop, entdata, 'WARMTETERUG_WTW_NIET');
                        }

                        relevant = true; //-- altijd relevant
                        break;
                    }
                case 'WARMTETERUG_TOELI': //-- V29
                    showit = conditieWH(entdata);
                    break;
                case 'WARMTETERUG_REND': //-- V24
                    {
                        const ventilatiekolom = _ventilatiekolommen.find(vk => vk.warmteterugwinning.EntityDataId === entdata.EntityDataId);
                        if (ventilatiekolom) {
                            showit = !warmteterugwinningIsHidden(ventilatiekolom);
                        }

                        if (showit) {
                            // Conditie [WL]
                            const propTypeWtw = _warmteterugwinningProperties['WARMTETERUG_TYPE'];
                            const typeWtw = propTypeWtw.getValue(entdata);
                            const hideIt = typeWtw === 'WARMTETYPE_GEEN' && !isHidden(propTypeWtw, entdata);
                            showit = !hideIt;
                        }
                        break;
                    }
                case 'WARMTETERUG_TOEL': //-- V30
                    {
                        // Conditie [WJ]
                        const toevoerkanaal = entdata.PropertyDatas['WARMTETERUG_TOELI'].Relevant ? entdata.PropertyDatas['WARMTETERUG_TOELI'].Value : '';
                        const sitA = toevoerkanaal === 'WARMTETOE_A' || toevoerkanaal === 'WARMTETOE_C' || toevoerkanaal === 'WARMTETOE_E';

                        // Conditie [SZ]
                        const gebouwType = ntaSharedLogic.getGebouwType();
                        const sit1 = gebouwType !== 'TGEB_APPGEB' && gebouwType !== 'TGEB_UTILIT' && !ntaSharedLogic.voorProjectwoningen();

                        const sit2 = !sit1 && ntaSharedLogic.perGebouw();

                        const sit3 = !sit1 && ntaSharedLogic.perGebouwEnAppartementOfUnit() && isLbkAanwezig();

                        const sitB = sit1 || sit2 || sit3;

                        showit = sitA && sitB;

                        break;
                    }
                case 'WARMTETERUG_TOEI': //-- V31
                    showit = conditieWK(entdata);
                    break;
                case 'WARMTETERUG_COE': //-- V32
                    showit = conditieWK(entdata);
                    break;
                case 'WARMTETERUG_SYS': {
                    showit = false; // dit veld is alleen bedoeld om het systeemtype te bepalen voor de rekenkern

                    const ventilatiekolom = _ventilatiekolommen.find(vk => vk.warmteterugwinning.EntityDataId === entdata.EntityDataId);
                    if (ventilatiekolom) {
                        relevant = !warmteterugwinningIsHidden(ventilatiekolom);
                    }
                    break;
                }
                case 'VENTILATOR_AAN': //-- V34
                    showit = conditieFA(entdata);
                    break;
                case 'VENTILATOR_INV': //-- V35
                    // conditie [FB] is omgekeerde van conditie [FA]
                    showit = !conditieFA(entdata);
                    break;
                case 'VENTILATOR_FABR': //-- V36
                    // Conditie FD
                    {
                        let ventilatiekolom = _ventilatiekolommen.find(vk => vk.ventilatoren.EntityDataId === entdata.EntityDataId);
                        if (ventilatiekolom) {
                            let propFabricagejaar = _warmteterugwinningProperties['WARMTETERUG_FABR'];
                            showit = isHidden(propFabricagejaar, ventilatiekolom.warmteterugwinning);
                        }

                        relevant = showit;

                        if (showit) {
                            // Conditie FC
                            let propInvoerVentilatorVermogen = _ventilatorenProperties['VENTILATOR_INV'];
                            let propValueInvoerVentilatorVermogen = propInvoerVentilatorVermogen.getValue(entdata);
                            showit = !isHidden(propInvoerVentilatorVermogen, entdata) && propValueInvoerVentilatorVermogen === 'VENTILATORFABR_A';
                            if (showit) {
                                if (ntaSharedLogic.getBouwjaar() >= 2010) {
                                    showit = false;
                                    let newVentilatorFabr = 'WARMTEFABR_NIEUW';
                                    saveValue(prop, entdata, newVentilatorFabr);
                                    relevant = true;
                                }
                            }
                        }
                        break;
                    }
                case 'VENTILATOR_TYPE': //-- V37
                    {
                        // Conditie FO
                        getCodedValues(prop, entdata); // update van de lijst mogelijke keuzes.
                        const propInvoerVentilatorVermogen = _ventilatorenProperties['VENTILATOR_INV'];
                        const propValueInvoerVentilatorVermogen = propInvoerVentilatorVermogen.getValue(entdata);
                        showit = !isHidden(propInvoerVentilatorVermogen, entdata) && propValueInvoerVentilatorVermogen === 'VENTILATORFABR_A';
                        if (showit) {
                            showit = ntaSharedLogic.getBouwjaar() < 2007;
                            if (!showit) {
                                let newVentilatorType = 'VENTILATORTYPE_GEL';
                                saveValue(prop, entdata, newVentilatorType);
                                relevant = true;
                            }
                        }
                        break;
                    }
                case 'VENTILATOREIG_DEB':
                    {   //-- V40
                        // Conditie RD
                        showit = conditieRD(entdata);
                        break;
                    }
                case 'VENTILATOREIG_JAAR': { //-- V42
                    // Conditie FH
                    const ventilatoren = ntaEntityData.getFirstParent(entdata, 'VENTILATOR');
                    if (ventilatoren) {
                        relevant = conditieFH(ventilatoren); //-- conditie FH verwacht een entdata van type VENTILATOR, hier komt type VENTILATOREIIG binnen, dus ff de parent zoeken.
                        showit = false;
                        if (relevant) {
                            //-- nu moet ik weten of mijn bouwjaar >= 2005, want dan is de prop ook hidden, maar wel relevant
                            showit = ntaSharedLogic.getBouwjaar() < 2005;
                            if (!showit) {
                                let newVentilatorJaar = 'VENTILATORJ_GR';
                                saveValue(prop, entdata, newVentilatorJaar);
                            }
                        }
                    }
                    break;
                }
                case 'VENTILATOREIG_U': // V43
                case 'VENTILATOREIG_I': // V44
                case 'VENTILATOREIG_E': { // V45
                    const ventilatoren = ntaEntityData.getFirstParent(entdata, 'VENTILATOR');
                    if (ventilatoren) {
                        let invoerVentilatorVermogen = ventilatoren.PropertyDatas['VENTILATOR_INV'].Value;
                        showit = invoerVentilatorVermogen === 'VENTILATORFABR_E';
                    }
                    break;
                }
                case 'VENTILATOREIG_PAS':   // V46
                case 'VENTILATOREIG_PNA': { // V47
                    const ventilatoren = ntaEntityData.getFirstParent(entdata, 'VENTILATOR');
                    if (ventilatoren) {
                        const invoerVentilatorVermogen = ventilatoren.PropertyDatas['VENTILATOR_INV'].Value;
                        showit = invoerVentilatorVermogen === 'VENTILATORFABR_D' || invoerVentilatorVermogen === 'VENTILATORFABR_E';
                    }

                    if (prop.Id === 'VENTILATOREIG_PNA') { // V47
                        relevant = showit;
                        showit = relevant && conditieMW_A();
                    }
                    break;
                }
                case 'VENTILATOREIG_PNB': { //-- V48
                    const ventilatoren = ntaEntityData.getFirstParent(entdata, 'VENTILATOR');
                    if (ventilatoren) {
                        const invoerVentilatorVermogen = ventilatoren.PropertyDatas['VENTILATOR_INV'].Value;
                        showit = invoerVentilatorVermogen === 'VENTILATORFABR_B' || invoerVentilatorVermogen === 'VENTILATORFABR_C';
                    }
                    break;
                }
                case 'VENTILATOREIG_FREG': {
                    showit = true; //-- property is altijd zichtbaar. Hier alleen uitzoeken of hij relevant is of niet.

                    const ventilatoren = ntaEntityData.getFirstParent(entdata, 'VENTILATOR');
                    if (ventilatoren) {
                        let invoerVentilatorVermogen = ventilatoren.PropertyDatas['VENTILATOR_INV'].Value;
                        relevant = invoerVentilatorVermogen === 'VENTILATORFABR_C';
                    }

                    //[MW-C] verberg veld als formulier wordt gebruikt bij HVAC maatregel EN waarde uit rekenkern komt (kan ook eigen invoer zijn)
                    if (!relevant) { // is nominaal ventilator vermogen - fregfan eigen waarde (VENTILATORFABR_C)
                        showit = showit && conditieMW_A();
                    }

                    break;
                }
                case 'VENTILATOR_VOL': //-- V50
                    showit = conditieFE(entdata);
                    break;
                case 'VENTILATOR_FRENDONB': //-- ?? staat niet in formulieren.xlsx
                    showit = false; //-- deze property nooit laten zien. Wanneer hij relevant is moet de selectietabel de waarde voor frend;onb vullen. dit gebeurt in conditieFE
                    relevant = !conditieFE(entdata);
                    break;
                case 'VENTILATOR_PNC': //-- V52
                    relevant = conditieFA(entdata);
                    showit = relevant && conditieMW_A();
                    break;
                case 'VENTILATOR_FREGB': { //-- V53
                    const conditionFA = conditieFA(entdata);
                    if (ntaSharedLogic.isUtiliteit()) {
                        // bij utiliteitsbouw nooit relevant, want dan moet de waarde uit de rekenkern komen
                        relevant = false;
                    } else {
                        relevant = conditionFA;
                    }
                    showit = conditionFA && conditieMW_A();
                    break;
                }
                case 'VENTDEB_CAP': //-- V55
                    showit = !werkelijkGeinstalleerdeVentilatiecapaciteitIsHidden();
                    if (showit) { //Zie Trello-kaartjes qzRPfBgX en UpzEqBi1
                        ntaEntityData.setEntityStatus(entdata, showit);
                    }
                    break;
                case 'VENTDEB_CAPTAB': //-- Tabel V56
                    showit = !werkelijkGeinstalleerdeVentilatiecapaciteitTabelIsHidden();
                    if (showit) { //Zie Trello-kaartjes qzRPfBgX en UpzEqBi1
                        ntaEntityData.setEntityStatus(entdata, showit);
                    }
                    break;
                case 'VENTCAP_ND': //-- V59
                    // Conditie DE
                    showit = conditieDE();
                    break;
                case 'VENTCAP_NV': //-- V60
                    {
                        // Conditie DF
                        let propNatuurlijkeToevoegVoorverwarmd = _voorverwarmingProperties['VOORWARM_NT'];
                        let propValueNatuurlijkeToevoerVoorverwarmd = propNatuurlijkeToevoegVoorverwarmd.getValue(_voorverwarmingData);
                        showit = !isHidden(propNatuurlijkeToevoegVoorverwarmd, _voorverwarmingData) && propValueNatuurlijkeToevoerVoorverwarmd !== 'VOORWARMNT_GEEN';
                        break;
                    }
                case 'VENTCAP_NAOS': //-- V61
                    showit = conditieDG();
                    break;
                case 'VENTCAP_MD': //-- V62
                    showit = conditieDH();
                    break;
                case 'VENTCAP_MV': //-- V63
                    showit = conditieDI();
                    break;
                case 'VENTDEB_ZBR': {
                    showit = conditieDN();
                    break;
                }
                case 'VENTDEB_ZBRTAB':
                    showit = conditieDO();
                    break;
                case 'VENTZBR_AANW':
                    showit = conditieDO();
                    break;
                case 'VENTZBR_AG':
                    showit = conditieDO();
                    break;
                case 'VENTDIS_C': //-- V66
                case 'VENTDIS_CVERW': //-- V67
                case 'VENTDIS_CKOEL': //-- V68
                case 'VENTDIS_LBK': //-- V69
                    {
                        showit = conditieRA();
                        break;
                    }
                case 'VENTDIS_REC': //-- V70
                    showit = conditieRG();
                    break;
                case 'VENTDIS_DEB': //-- V71
                    showit = conditieRC();
                    break;
                case 'VENTILATOR_PNOM1':
                case 'VENTILATOR_PNOM2':
                case 'VENTILATOR_PNOM3': {
                    // Pnom 1, 2 en 3 zijn alleen relevant als Pnom vanuit de rekenkern komt, dus VENTILATOR_PNC is ook relevant
                    const propPnom = _ventilatorenProperties['VENTILATOR_PNC'];

                    showit = false;

                    // VENTILATOR_PNC kan hidden zijn maar wel relevant (conditie [MW-A])
                    relevant = isRelevant(propPnom, entdata);
                    break;
                }
                case 'MEASURE-COSTS_SUBS_INV':
                case 'MEASURE-COSTS_SUBS_PER_M2':
                case 'MEASURE-COSTS_INV':
                case 'MEASURE-COSTS_PER_M2': {
                    showit = false;
                    break;
                }
            }

            // standaard is relevant gelijk aan visible
            if (relevant === null) relevant = showit;

            const propdatas = [propdata, ...ntaSharedLogic.getUnitSpecificResultPropdatas(prop, entdata)];
            ntaEntityData.setPropdataStatus(propdatas, relevant, showit);

            return !showit;
        } //-- end: isHidden ------------------------------------------------------------------------//

        function isLbkAanwezig() { // V83
            return (!isHidden('VENT_GEM', _ventData) && _ventData.PropertyDatas['VENT_GEM'].Value === 'VENT_GEM_WEL')
                || (!isHidden('VENT_LBK', _ventData) && _ventData.PropertyDatas['VENT_LBK'].Value === 'VENT_LBK_WEL');
        }

        /* Condities ************************************************************************************************/

        function conditieMW_A() {
            // [MW-A] verberg veld als formulier wordt gebruikt bij HVAC maatregel
            // LET OP: dit moet GEEN invloed hebben op de relevantie!

            // Maar als iets niet zichtbaar moet zijn bij het bewerken van een maatregel,
            //  moet het ook niet zichtbaar zijn bij het valideren van een variant.
            return !ntaSharedLogic.isEditingMeasure()
                && !ntaSharedLogic.isValidatingVariant();
        } //-- end: conditieMW_A ------------------------------------------------------------------

        function conditieDN() {
            //Conditie [DN] toon veld als versie = ge3-2 EN minimaal 1 van de gebruiksfunties Z14 in een van de rekenzones aangesloten op het ventilatiesysteem = sportfunctie (ID9 van table_uti)
            const unitRzGfs = ntaEntityData.findEntities(_ventData, "RZ.UNIT-RZ.UNIT-RZ-GF");
            return unitRzGfs.some(gf => gf.PropertyDatas['UNIT-RZ-GFID'].Value === 'GF_SPORT');
        }


        function conditieDO() {
            //Conditie [DO] toon tabel als V86 (VENTDEB_ZBR) = sportfunctie met zwembadruimte aanwezig
            const zbrProp = _ventilatiedebietProperties['VENTDEB_ZBR'];
            const propdata = zbrProp.getData(_ventilatiedebietData);

            if (!propdata.Relevant || propdata.Value !== 'VENTDEB_ZBR_AANW') { // als ZBR niet aanwezig is, alle props van de zbrs niet relvant maken
                const ventzbrs = ntaEntityData.getChildren(_ventilatiedebietData, "VENTZBR");
                const zbrPropdatas = ventzbrs.flatMap(ventzbr => ventzbr.PropertyDatas);
                ntaEntityData.setPropdataStatus(zbrPropdatas, false, false);
            }

            return propdata.Relevant && propdata.Value === 'VENTDEB_ZBR_AANW';
        }

        function conditieSY(entdata) {
            // [SY] toon veld indien V03 = B, C of Dc EN G04=appartementengebouw/appartement (voor bestaande bouw)/utiliteitsgebouw/unit in utiliteitsgebouw
            const ventilatiesysteemtype = entdata.PropertyDatas['VENT_SYS'].Value;
            const gebouwtype = ntaSharedLogic.getGebouwType();
            return ['VENTSYS_MECH', 'VENTSYS_NATMECH', 'VENTSYS_MECHC'].includes(ventilatiesysteemtype)
                && ['TGEB_APPGEB', 'TGEB_APP', 'TGEB_UTILIT', 'TGEB_UTILUNIT'].includes(gebouwtype);
        } //-- end: conditieSY ------------------------------------------------------------------------//

        function conditieWK(entdata) {
            //-- toon als V29 = 'toevoerkanaal geïsoleerd - type isolatie bekend - lengte bekend' of 'toevoerkanaal geïsoleerd - type isolatie bekend - lengte onbekend'
            const propdataToevoerkanaal = entdata.PropertyDatas['WARMTETERUG_TOELI']
            const toevoerkanaal = propdataToevoerkanaal.Value;

            const showIt = propdataToevoerkanaal.Visible && (toevoerkanaal === 'WARMTETOE_E' || toevoerkanaal === 'WARMTETOE_F');

            return showIt; //-- bij showIt True is de conditie geldig.
        } //-- end: conditieWK ------------------------------------------------------------------------//

        function conditieWB(ventilatiekolom) {
            //-- conditiewB begint met Toon....
            let showIt = false;

            const wtw = ventilatiekolom.warmteterugwinning;
            const propdataWtwInvoer = wtw.PropertyDatas['WARMTETERUG_INV']; // V95
            if (propdataWtwInvoer) {

                // Vanaf alle versies horend bij release 3.4 bestaat V95. Als dat zo is, is de conditie:
                // [WB] toon als V95 = forfaitair
                showIt = propdataWtwInvoer.Visible && propdataWtwInvoer.Value === 'WTWINV_FORF';

            } else {

                // In vergrendelde berekeningen van voor de release van versie 3.4 bestond V95 niet, en is de conditie iets anders:
                // [WB] veld tonen indien V05='forfaitair' of 'eigen waarde' (kolom 1) of V11='forfaitair' of 'eigen waarde' (kolom 2)
                const propIdInvoer = ventilatiekolom.isAanvullendSysteem ? 'VENTAAN_INVOER' : 'VENT_INVOER'; // V11 of V05
                const invoer = ventilatiekolom.entdata.PropertyDatas[propIdInvoer].Value;

                showIt = invoer === 'VENT_EIG' || invoer === 'VENT_FORF';
            }

            return showIt; //-- bij showIt True is de conditie geldig.
        } //-- end: conditieWB ------------------------------------------------------------------------//

        function conditieWH(entdataWTW) {
            //-- [WH] toon als V24 > 0
            let showIt = false;

            const propRendement = _warmteterugwinningProperties['WARMTETERUG_REND']; // V24

            showIt = !isHidden(propRendement, entdataWTW)
                && ntaSharedLogic.parseFloat(propRendement.getValue(entdataWTW), 0) > 0;

            return showIt; //-- bij showIt True is de conditie geldig.
        } //-- end: conditieWH ------------------------------------------------------------------------//

        function conditieWN(entdata, ventilatiekolom) {
            //-- Conditie [WN] begint met Toon....
            let showIt = false;

            const propWtwInvoer = _warmteterugwinningProperties['WARMTETERUG_INV']; // V95
            if (propWtwInvoer) {
                // [WN] toon veld als: V95 ≠ productspecifiek EN V24>0
                const propdataWtwInvoer = propWtwInvoer.getData(ventilatiekolom.warmteterugwinning);
                showIt = propdataWtwInvoer.Visible
                    && propdataWtwInvoer.Value !== 'WTWINV_PROD'
                    && conditieWH(entdata); // V24 > 0
            } else {
                //-- Conditie WN was een combinatie van WB en WH.
                showIt = conditieWB(ventilatiekolom) && conditieWH(entdata);
            }

            return showIt;  //-- bij showIt True is de conditie geldig.
        } //-- end: conditieWN ------------------------------------------------------------------------//

        function conditieWQ(ventilatiekolom) {
            // [WQ] toon onder kolom 1 als: V03 = Dc, Dd of E EN voor de keuze gemaakt in V06 geldt dat VE_model kolom 'variant' ≠ D.1 EN kolom eta_hr = leeg
            //      toon onder kolom 2 als: V09 = Dc, Dd of E EN voor de keuze gemaakt in V12 geldt dat VE_model kolom 'variant' ≠ D.1 EN kolom eta_hr = leeg
            const sysPropId = ventilatiekolom.isAanvullendSysteem ? 'VENTAAN_SYS' : 'VENT_SYS'; // V09 of V03
            const sysType = ventilatiekolom.entdata.PropertyDatas[sysPropId].Value;
            if (!['VENTSYS_MECHC', 'VENTSYS_MECHD', 'VENTSYS_GEC'].includes(sysType)) { // Dc, Dd of E
                return false;
            }

            const sysVarPropId = ventilatiekolom.isAanvullendSysteem ? 'VENTAAN_SYSVAR' : 'VENT_SYSVAR'; // V12 of V06
            const product = getSelectedProduct(sysVarPropId, ventilatiekolom.entdata);
            const visible = product && product.Variant !== 'D.1' && product.eta_hr === null;

            // conditie [WQ] begint met ‘toon’
            return visible;
        } // end: conditieWQ --------------------------------------------------------------------//

        function conditieWR(entdata) {
            // [WR] toon als V95 = productspecifiek
            const propdataWtwInvoer = entdata.PropertyDatas['WARMTETERUG_INV']; // V95
            return !!propdataWtwInvoer?.Visible && propdataWtwInvoer.Value === 'WTWINV_PROD';
        } //-- end: conditieWR ------------------------------------------------------------------//

        function conditieFA(entdataVentilator) {
            //-- Conditie [FA], omgekeerd conditie [FB]. Conditie begint met Toon......
            // [FA] kolom 1: toon veld indien waarde in tabel VE_model (corresponderend met invoer veld V06 of V96) kolom Pnom1 of Pnom2 of Pnom3
            //    - kolom 2: toon veld indien waarde in tabel VE_model (corresponderend met invoer veld V12 of V96) kolom Pnom1 of Pnom2 of Pnom3
            const isHoofdsys = !ntaSharedLogic.hasRelation(_ventAanvullendData, entdataVentilator);
            const kolom = isHoofdsys ? _ventilatieKolom : _ventilatieAanvullendKolom;
            const product = getMatchingProduct(kolom, p => p.Pnom1 !== null || p.Pnom2 !== null || p.Pnom3 !== null);

            const showIt = !!product;

            return showIt; //-- bij showIt True is de conditie geldig.
        } //-- end: conditieFA ------------------------------------------------------------------------//

        function conditieFE(entdataVentilator) {
            //-- Conditie [FE] kolom 1: toon veld indien geen waarde in tabel VE_model (corresponderend met invoer veld V06 of V96) kolom frend_onb EN V24 > 0
            //               - kolom 2: toon veld indien geen waarde in tabel VE_model (corresponderend met invoer veld V12 of V96) kolom frend_onb EN V24 > 0
            let showIt = false;

            const ventilatiekolom = _ventilatiekolommen.find(vk => vk.ventilatoren.EntityDataId === entdataVentilator.EntityDataId)
            if (ventilatiekolom) {
                const product = getMatchingProduct(ventilatiekolom, p => p.frend_onb !== null);
                if (product) {
                    ///-- de selectietabel heeft een waarde voor frend;onb. Deze waarde overnemen en in
                    ///-- property "VENTILATOR_FRENDONB" zetten, zodat de rekenkern deze waarde gebruikt indien nodig
                    saveValue('VENTILATOR_FRENDONB', ventilatiekolom.ventilatoren, product.frend_onb);
                }

                const frend_onbAanwezig = !!product;
                showIt = !frend_onbAanwezig && conditieWH(ventilatiekolom.warmteterugwinning); // [WH] toon indien V24 > 0
            }

            return showIt;  //-- bij showIt True is de conditie geldig.
        } //-- end: conditieFE ------------------------------------------------------------------------//

        function conditieFH(entdata) {
            //-- als de conditie waar is geef hij true terug bij niet waar false; let op met hidden
            let result = false;
            const ventilatoren_0 = ntaEntityData.get(entdata.EntityDataId);
            if (ventilatoren_0) {
                const invoerVentilatorVermogen = ventilatoren_0.PropertyDatas['VENTILATOR_INV'].Value;
                result = (invoerVentilatorVermogen === 'VENTILATORFABR_D' || invoerVentilatorVermogen === 'VENTILATORFABR_E');
            }
            return result;
        } //-- end: conditieFH ------------------------------------------------------------------------//

        function conditieDE() {
            //-- conditieDE begint met Toon...
            let showIt = false;

            let propValueVentsys = _ventData.PropertyDatas['VENT_SYS'].Value;
            let propValueVentsysAanvullend = _ventAanvullendData.PropertyDatas['VENTAAN_SYS'].Value;
            let aanvullendSysteemZichtbaar = propValueVentsys === 'VENTSYS_GEC';
            showIt = propValueVentsys === 'VENTSYS_NAT' || propValueVentsys === 'VENTSYS_NATMECH';
            if (aanvullendSysteemZichtbaar && !showIt) {
                showIt = propValueVentsysAanvullend === 'VENTSYS_NAT' || propValueVentsysAanvullend === 'VENTSYS_NATMECH';
            }

            return showIt; //-- bij showIt True is de conditie geldig.
        } //-- end: conditieDE ------------------------------------------------------------------------//

        function conditieDG() {
            //-- Conditie DG begint met Toon...
            let showIt = false;

            let propValueVentsys = _ventData.PropertyDatas['VENT_SYS'].Value;
            let propValueVentsysAanvullend = _ventAanvullendData.PropertyDatas['VENTAAN_SYS'].Value;
            let aanvullendSysteemZichtbaar = propValueVentsys === 'VENTSYS_GEC';
            let sitA = propValueVentsys === 'VENTSYS_NAT' || propValueVentsys === 'VENTSYS_NATMECH';
            if (aanvullendSysteemZichtbaar && !sitA) {
                sitA = propValueVentsysAanvullend === 'VENTSYS_NAT' || propValueVentsysAanvullend === 'VENTSYS_NATMECH';
            }

            //-- Controleer of een rekenzone van het type AOS is
            let rekenzones = ntaEntityData.getListWithEntityId('RZ');

            let hasAOS = false;
            let index;
            for (index = 0; index < rekenzones.length; index++) {
                let zoneType = rekenzones[index].PropertyDatas['RZ_TYPEZ'].Value;

                if (zoneType === 'AOS') {
                    hasAOS = true;
                    break;
                }
            }

            let sitB = hasAOS;

            showIt = sitA && sitB;

            return showIt;   //-- bij showIt True is de conditie geldig.
        } //-- end: conditieDG ------------------------------------------------------------------------//

        function conditieDH() {
            //-- ConditieDH begint met Toon...
            let showit = false;

            // V03-V09 en V24 controleren
            let bSitA = false;

            // V03 controleren
            let ventsys = _ventData.PropertyDatas['VENT_SYS'].Value;
            let validSys = (ventsys === 'VENTSYS_MECH' || ventsys === 'VENTSYS_MECHC' || ventsys === 'VENTSYS_MECHD' || ventsys === 'VENTSYS_GEC') ;

            // V09 controleren
            let aanvullendSysteemZichtbaar = ventsys === 'VENTSYS_GEC';
            let ventsysAanvullend = _ventAanvullendData.PropertyDatas['VENTAAN_SYS'].Value;
            let validSysAanvullend = aanvullendSysteemZichtbaar && (ventsysAanvullend === 'VENTSYS_MECH' || ventsysAanvullend === 'VENTSYS_MECHC' || ventsysAanvullend === 'VENTSYS_MECHD' || ventsysAanvullend === 'VENTSYS_GEC');

            // V24, systeem
            let valueRendement = 0;
            let propRendement = _warmteterugwinningProperties['WARMTETERUG_REND'];
            if (!isHidden(propRendement, _warmteterugwinningData) && !warmteterugwinningIsHidden(_ventilatieKolom)) {
                let rendement = propRendement.getValue(_warmteterugwinningData);
                if (rendement) {
                    valueRendement = ntaSharedLogic.parseFloat(rendement);
                }
            }
            let valueRendementAanv = 0;
            if (aanvullendSysteemZichtbaar) {
                // V24, aanvullend systeem
                if (!isHidden(propRendement, _warmteterugwinningAanvullendData) && !warmteterugwinningIsHidden(_ventilatieAanvullendKolom) && !kolomIsHidden(_ventilatieAanvullendKolom)) {
                    let rendementAanvullend = propRendement.getValue(_warmteterugwinningAanvullendData);
                    if (rendementAanvullend) {
                        valueRendementAanv = ntaSharedLogic.parseFloat(rendementAanvullend);
                    }
                }
            }

            bSitA = validSys && valueRendement === 0;
            if (!bSitA && aanvullendSysteemZichtbaar) {
                bSitA = validSysAanvullend && valueRendementAanv === 0;
            }

            // V67 controleren
            let bSitB = false;
            let propVerwbat = _ventilatiedistributieProperties['VENTDIS_CVERW'];
            let propValueVerwbat =  propVerwbat.getValue(_ventilatiedistributieData);

            let batVerwHidden = isHidden(propVerwbat, _ventilatiedistributieData);
            if ((!batVerwHidden && propValueVerwbat === 'VENTDIS_CVERW_GEEN') || (batVerwHidden)) {
                bSitB = true;
            }

            //// V68 controleren
            //let bSitC = false;
            //let propKoelbat = _ventilatiedistributieProperties['VENTDIS_CKOEL'];
            //let propValueKoelbat = propKoelbat.getValue(_ventilatiedistributieData);

            //if (isHidden(propKoelbat, _ventilatiedistributieData) || (!!propValueKoelbat && propValueKoelbat === 'VENTDIS_CKOEL_GEEN')) {
            //    bSitC = true;
            //}

            showit = bSitA && bSitB/* && bSitC*/;

            return showit; //-- bij showIt True is de conditie geldig.
        } //-- end: conditieDH ------------------------------------------------------------------------//

        function conditieDI() {
            //-- Conditie [DI] begint met Toon.....
            let showit = false;

            // V03-V09 en V24 controleren
            let bSitA = false;
            let propdataVentsys = _ventData.PropertyDatas['VENT_SYS'];
            let propdataVentsysAanv = _ventAanvullendData.PropertyDatas['VENTAAN_SYS'];
            let validSys = false;
            if (propdataVentsys) {
                validSys = propdataVentsys.Value === 'VENTSYS_MECH' || propdataVentsys.Value === 'VENTSYS_MECHC' || propdataVentsys.Value === 'VENTSYS_MECHD' || propdataVentsys.Value === 'VENTSYS_GEC';
            }
            if (!validSys && !kolomIsHidden(_ventilatieAanvullendKolom)) {
                if (propdataVentsysAanv) {
                    validSys = propdataVentsysAanv.Value === 'VENTSYS_MECH' || propdataVentsysAanv.Value === 'VENTSYS_MECHC' || propdataVentsysAanv.Value === 'VENTSYS_MECHD' || propdataVentsysAanv.Value === 'VENTSYS_GEC';
                }
            }

            let valueRendement = 0;
            let propRendement = _warmteterugwinningProperties['WARMTETERUG_REND'];
            if (!warmteterugwinningIsHidden(_ventilatieKolom) && !isHidden(propRendement, _warmteterugwinningData)) {
                let propdataRendement = _warmteterugwinningData.PropertyDatas[propRendement.Id];
                if (propdataRendement && propdataRendement.Value) {
                    valueRendement = ntaSharedLogic.parseFloat(propdataRendement.Value);
                }
            }
            let valueRendementAanv = 0;
            if (!warmteterugwinningIsHidden(_ventilatieAanvullendKolom) && !isHidden(propRendement, _warmteterugwinningAanvullendData) && !kolomIsHidden(_ventilatieAanvullendKolom)) {
                let propdataRendementAanv = _warmteterugwinningAanvullendData.PropertyDatas[propRendement.Id];
                if (propdataRendementAanv && propdataRendementAanv.Value) {
                    valueRendementAanv = ntaSharedLogic.parseFloat(propdataRendementAanv.Value);
                }
            }
            bSitA = validSys && (valueRendement > 0 || valueRendementAanv > 0);

            // V67 controleren
            let bSitB = false;
            let propVerwbat = _ventilatiedistributieProperties['VENTDIS_CVERW'];
            let propValueVerwbat = propVerwbat.getValue(_ventilatiedistributieData);

            if (!isHidden(propVerwbat, _ventilatiedistributieData) && propValueVerwbat === 'VENTDIS_CVERW_WEL') {
                bSitB = true;
            }

            // V68 controleren
            let bSitC = false;
            let propKoelbat = _ventilatiedistributieProperties['VENTDIS_CKOEL'];
            let propValueKoelbat = propKoelbat.getValue(_ventilatiedistributieData);

            if (!isHidden(propKoelbat, _ventilatiedistributieData) && propValueKoelbat === 'VENTDIS_CKOEL_WEL') {
                bSitC = true;
            }

            showit = bSitA || bSitB || bSitC;

            return showit; //-- bij showIt True is de conditie geldig.
        } //-- end: conditieDI ------------------------------------------------------------------------//

        function conditieRA() {
            // Conditie RA begint met Toon...
            let showIt = false;

            let propValueVentsys = _ventData.PropertyDatas['VENT_SYS'].Value;
            let propValueVentsysAanvullend = _ventAanvullendData.PropertyDatas['VENTAAN_SYS'].Value;
            let aanvullendSysteemZichtbaar = propValueVentsys === 'VENTSYS_GEC';
            let sitA = propValueVentsys === 'VENTSYS_MECH' || propValueVentsys === 'VENTSYS_MECHC';
            if (aanvullendSysteemZichtbaar && !sitA) {
                sitA = propValueVentsysAanvullend === 'VENTSYS_MECH' || propValueVentsysAanvullend === 'VENTSYS_MECHC';
            }

            const sitB = isLbkAanwezig();

            showIt = sitA && sitB;
            return showIt;  //-- bij showIt True is de conditie geldig.
        } //-- end: conditieRA ------------------------------------------------------------------------//

        function conditieRC() {
            //--- Conditie RC begint met Toon...
            let showIt = false;

            let propValueVentsys = _ventData.PropertyDatas['VENT_SYS'].Value;
            let propValueVentsysAanvullend = _ventAanvullendData.PropertyDatas['VENTAAN_SYS'].Value;
            let aanvullendSysteemZichtbaar = propValueVentsys === 'VENTSYS_GEC';
            let sitA = propValueVentsys === 'VENTSYS_MECH' || propValueVentsys === 'VENTSYS_MECHC';
            if (aanvullendSysteemZichtbaar && !sitA) {
                sitA = propValueVentsysAanvullend === 'VENTSYS_MECH' || propValueVentsysAanvullend === 'VENTSYS_MECHC';
            }

            let sitB = isLbkAanwezig();

            let sitC = false;
            if (!werkelijkGeinstalleerdeVentilatiecapaciteitIsHidden()) {
                let propVentcap = _ventilatiedebietProperties['VENTDEB_CAP']; // V55
                let propValueVentcap = propVentcap.getValue(_ventilatiedebietData);
                sitC = propValueVentcap === 'VENTDEBCAP_BEK';
            }

            showIt = sitA && sitB && sitC;

            return showIt; //-- bij showIt True is de conditie geldig.
        } //-- end: conditieRC ------------------------------------------------------------------------//

        function conditieRD(entdata) {
            //-- conditie RD begint met Toon....

            const propDebietRegeling = _ventilatiedistributieProperties['VENTDIS_DEB']; // V71
            const debietRegeling = propDebietRegeling.getValue(_ventilatiedistributieData);
            let visible = !isHidden(propDebietRegeling, _ventilatiedistributieData)
                && !!debietRegeling && debietRegeling !== 'VENTDIS_DEB_GEEN';

            if (visible) {
                const ventilatoren = entdata.EntityId === 'VENTILATOR'
                    ? entdata
                    : entdata.EntityId === 'VENTILATOREIG'
                        ? ntaEntityData.getFirstParent(entdata, 'VENTILATOR')
                        : null;
                const propInvVentVermogen = _ventilatorenProperties['VENTILATOR_INV']; // V35
                const invVentVermogen = ventilatoren && propInvVentVermogen.getValue(ventilatoren);
                visible = ['VENTILATORFABR_B', 'VENTILATORFABR_D', 'VENTILATORFABR_E'].includes(invVentVermogen);
            }

            return visible;
        } //-- end: conditieRD ------------------------------------------------------------------------//

        function conditieRG() {
            //-- Conditie RG begint met Toon....
            let showIt = false;

            let propValueVentsys = _ventData.PropertyDatas['VENT_SYS'].Value;
            let propValueVentsysAanvullend = _ventAanvullendData.PropertyDatas['VENTAAN_SYS'].Value;
            let aanvullendSysteemZichtbaar = propValueVentsys === 'VENTSYS_GEC';
            let sitA = propValueVentsys === 'VENTSYS_MECHC';
            if (aanvullendSysteemZichtbaar && !sitA) {
                sitA = propValueVentsysAanvullend === 'VENTSYS_MECHC';
            }
            let propVentcap = _ventilatiedebietProperties['VENTDEB_CAP']; // V55
            let propValueVentcap = propVentcap.getValue(_ventilatiedebietData);
            let sitB = propValueVentcap === 'VENTDEBCAP_BEK';

            if (!ntaSharedLogic.isUtiliteit() && sitB) {
                //-- bij woningbouw en ventilatiecapaciteit bekend moet ik ook nog checken of er een LBK aanwezig is
                sitB = isLbkAanwezig();
            }

            showIt = sitA && sitB;

            return showIt; //-- bij showIt True is de conditie geldig.
        } //-- end: conditieRG ------------------------------------------------------------------------//

        function bepaalWtwSysteem(kolom) {
            const product = getMatchingProduct(kolom, product => product.eta_hr !== null);
            if (product)
                return 'WARMTETYPE_REN1'; // OverigEN13141

            const propdataInvoer = kolom.warmteterugwinning.PropertyDatas['WARMTETERUG_INV']; // V95
            if (propdataInvoer?.Visible) {
                switch (propdataInvoer.Value) {
                    case 'WTWINV_FORF':
                        // dan moeten we WARMTETERUG_TYPE gebruiken
                        break;
                    case 'WTWINV_REN1':
                        return 'WARMTETYPE_REN1'; // OverigEN13141
                    case 'WTWINV_REN2':
                        return 'WARMTETYPE_REN2'; // OverigEN13142
                    case 'WTWINV_REN3':
                        return 'WARMTETYPE_REN3'; // OverigEN13053
                    default:
                        $log.warn('Onverwachte WTW-invoer:', propdataInvoer);
                        break;
                }
            }

            let wtwSysteem = 'WARMTETYPE_GEEN'; // Geen

            const propdataType = kolom.warmteterugwinning.PropertyDatas['WARMTETERUG_TYPE']; // V26
            if (propdataType.Visible) {
                wtwSysteem = propdataType.Value;
            }

            const overigeTypes = new Set(['WARMTETYPE_REN1', 'WARMTETYPE_REN2', 'WARMTETYPE_REN3', 'WARMTETYPE_ONB']);
            const propRendement = ntabuilding.properties['WARMTETERUG_REND']; // V24
            const propdataRendement = propRendement.getData(kolom.warmteterugwinning);
            if (!overigeTypes.has(wtwSysteem)
                && propdataRendement.Visible
                && ntaSharedLogic.parseFloat(propdataRendement.Value)
                && !isReadOnly(propRendement, kolom.warmteterugwinning)
            ) {
                if (wtwSysteem !== 'WARMTETYPE_GEEN') {
                    $log.warn('Onverwacht WTW-systeem bij rendement > 0:', propdataRendement, 'overschrijft eerdere keuze voor', wtwSysteem);
                }
                wtwSysteem = 'WARMTETYPE_ONB'; // Overig; omdat anders eta_hr niet wordt gebruikt door de rekenkern
            }

            return wtwSysteem;
        } //-- end: bepaalWtwSysteem ------------------------------------------------------------//

        function werkelijkGeinstalleerdeVentilatiecapaciteitIsHidden() {
            //-- Conditie [DA] begint met Verberg...
            let hideIt = false;

            //conditie [DA] Als versie = ge3-2 verberg als in V89 alle rekenzones gekoppeld aan dit ventilatiesysteem zijn aangevinkt
            if (ntabuilding.appVersionId >= 200) {
                const ventzbrs = ntaEntityData.getChildren(_ventilatiedebietData, "VENTZBR");
                const prop = _ventzwembadruimteProperties['VENTZBR_AANW']
                return conditieDN() && conditieDO() && ventzbrs.every(ventzbr => !prop.getData(ventzbr).Relevant || prop.getData(ventzbr).Value === "True"); //conditieDO() en conditieDN() omdat zwembadruimtes uberhaupt aanwezig moeten zijn
            }

            // conditie [DA] alleen bij versie 3.0; vanaf 3.1 altijd weergeven
            if (ntabuilding.appVersionId >= 100) {
                return hideIt;
            }


            // Voorverwarming controleren
            if (voorverwarmingInDeelToevoerroosters()) {
                return hideIt;
            }

            // Systeem controleren
            if (!ntaSharedLogic.isUtiliteit()) {

                const product = getSelectedProduct('VENT_SYSVAR', _ventData);
                if (product && product.Vraaggestuurd) { // Vraaggestuurd is ja
                    hideIt = true;
                }
            }

            if (!hideIt) {
                // Ook nog het eventuele aanvullende systeem controleren
                const propSysteemInvoer = _ventProperties['VENT_INVOER'];
                const propValueSysteemInvoer = propSysteemInvoer.getValue(_ventData);

                if (!ntaSharedLogic.isUtiliteit() && propValueSysteemInvoer === 'VENTSYS_GEC') {
                    const product = getSelectedProduct('VENTAAN_SYSVAR', _ventAanvullendData);
                    hideIt = product && product.Vraaggestuurd; // Vraaggestuurd is ja
                }
            }

            return hideIt;
        } //-- end: werkelijkGeinstalleerdeVentilatiecapaciteitIsHidden ------------------------------------------------------------------------//

        function werkelijkGeinstalleerdeVentilatiecapaciteitTabelIsHidden() {
            //-- Conditie [DJ] begint met Toon....
            let showIt = false;

            // Werkelijk geinstalleerde ventilatiecapaciteiten controleren
            const propVentcap = _ventilatiedebietProperties['VENTDEB_CAP'];
            const propValueVentcap = propVentcap.getValue(_ventilatiedebietData);

            // Voorverwarming controleren
            const propAandeelVoorverwarming = _voorverwarmingProperties['VOORWARM_AAN'];
            const propValueAandeelVoorverwarming = propAandeelVoorverwarming.getValue(_voorverwarmingData);

            showIt = (!isHidden(propVentcap, _ventilatiedebietData) && propValueVentcap === 'VENTDEBCAP_BEK') ||
                     (!isHidden(propAandeelVoorverwarming, _voorverwarmingData) && propValueAandeelVoorverwarming === 'VOORWARMAAN_DEEL' && (!voorverwarmingIsHidden(_ventilatieKolom) || !voorverwarmingIsHidden(_ventilatieAanvullendKolom)));

            // Relevantie entiteiten ventcap
            const entdatas = _units.flatMap(unit => getUnitRekenzones(unit)).flatMap(unitRekenzone => getVentilatiecapaciteit(unitRekenzone)).filter(ed => ed);
            ntaEntityData.setEntityStatus(entdatas, showIt);
            return !showIt;
        } //-- end: werkelijkGeinstalleerdeVentilatiecapaciteitTabelIsHidden ------------------------------------------------------------------------//

        function kolomIsHidden(ventilatiekolom) {
            //-- Conditie [SB] en [SC]
            let isHidden = true;

            if (!ventilatiekolom) {
                return isHidden;
            }

            if (ventilatiekolom.isAanvullendSysteem) {
                const showKolom = conditieSB(); //-- alleen als kolom 1 een E-systeem is moet de kolom zichtbaar zijn.

                // Relevantie voor het aanvullende systeem zetten
                ntaEntityData.setEntityStatus(_ventAanvullendData, showKolom);

                // Relevantie voor de andere entiteiten van het aanvullende systeem zetten.
                // Dit is alleen nodig als de kolom hidden is. Als de kolom wel zichtbaar is, zullen de specifieke IsHidden methodes de entiteiten zichtbaar maken.
                // Als alles zichtbaar wordt gemaakt bij het zichtbaar zijn van de kolom treedt er een conflict met de IsHidden methodes op en kunnen entiteiten onterecht relevant en visible worden.
                if (!showKolom) {
                    const entdatasToUpdate = _ventAanvullendData.tempUnits.map(tempUnit => tempUnit.verblijfsgebied)
                        .concat(ventilatiekolom.warmteterugwinning)
                        .concat((ventilatiekolom.warmteterugwinning.tempUnits || []).map(tempUnit => tempUnit.toevoerkanaal))
                        .filter(ed => ed); // eventuele nulls eruit filteren
                    ntaEntityData.setEntityStatus(entdatasToUpdate, showKolom);

                    ntaEntityData.setEntityRelevancy(ventilatiekolom.ventilatoren, showKolom);
                    setRelevancyVentilatorEigenschappen(ventilatiekolom, showKolom);
                }

                isHidden = !showKolom;

            } else {
                //-- Het ventilatiesysteem in de eerste kolom kan nooit verborgen zijn
                isHidden = false;
            }

            return isHidden;
        } //-- end: kolomIsHidden ------------------------------------------------------------------------//

        function verblijfsgebiedTabelIsHidden(ventilatiekolom) {
            //-- Conditie [SB] en [SX]

            if (!ventilatiekolom) {
                return true;
            }

            //-- Als de ventilatiekolom hidden is, moet de hele tabel hidden zijn
            const visible = !kolomIsHidden(ventilatiekolom)
                && conditieSB() && conditieSX();

            const verblijfsgebieden = ventilatiekolom.entdata.tempUnits
                .map(tempUnit => tempUnit.verblijfsgebied)
                .filter(gebied => gebied);
            ntaEntityData.setEntityStatus(verblijfsgebieden, visible);

            return !visible;
        } //-- end: verblijfsgebiedTabelIsHidden ------------------------------------------------------------------------//

        function toevoerkanaalTabelIsHidden(ventilatiekolom) {
            //--- Conditie [SAA] begint met Toon...
            if (!ventilatiekolom) {
                return true;
            }

            let showIt = false;

            if (!(kolomIsHidden(ventilatiekolom) || warmteterugwinningIsHidden(ventilatiekolom))) {
                const sitA = ["TGEB_APPGEB", "TGEB_UTILIT"].includes(ntaSharedLogic.getGebouwType()) && ntaSharedLogic.perGebouwEnAppartementOfUnit()
                    || ntaSharedLogic.voorProjectwoningen();

                const wtwToevLeidIso = ventilatiekolom.warmteterugwinning.PropertyDatas['WARMTETERUG_TOELI'].Relevant ? ventilatiekolom.warmteterugwinning.PropertyDatas['WARMTETERUG_TOELI'].Value : '';
                const sitB = ['WARMTETOE_A', 'WARMTETOE_C', 'WARMTETOE_E'].includes(wtwToevLeidIso);

                //-- controleren of er geen luchtbehandelingskast aanwezig is. Voorheen heette dit "niet-gemeenschappelijk installatie"
                const sitC = !isLbkAanwezig();

                const sitD = _ventData.PropertyDatas['VENT_SYS'].Value === 'VENTSYS_GEC';

                showIt = sitA && sitB && (sitC || sitD);
            }

            const toevoerkanalen = ventilatiekolom.warmteterugwinning.tempUnits.map(tempUnit => tempUnit.toevoerkanaal);
            ntaEntityData.setEntityStatus(toevoerkanalen, showIt);

            return !showIt;
        } //-- end: toevoerkanaalTabelIsHidden ------------------------------------------------------------------------//

        function voorverwarmingIsHidden(ventilatiekolom) {
            // Conditie VA begint met Toon...
            if (!ventilatiekolom) {
                return true;
            }

            let na2010 = ntaSharedLogic.getBouwjaar() >= 2010;

            let propSysId = ventilatiekolom.isAanvullendSysteem ? 'VENTAAN_SYS' : 'VENT_SYS';
            let propValueSys = ventilatiekolom.entdata.PropertyDatas[propSysId].Value;

            //-- Alleen tonen als het systeem A of C is en het bouwjaar na 2010 is
            let showIt = (propValueSys === 'VENTSYS_NAT' || propValueSys === 'VENTSYS_NATMECH') && na2010;

            //-- Voorwaarde is wel dat de ventilatiekolom zichtbaar moet zijn, wat in het geval van aanvullende kolom ff gecheckt moet worden
            if (ventilatiekolom.isAanvullendSysteem) {
                showIt = showIt && _ventData.PropertyDatas['VENT_SYS'].Value === 'VENTSYS_GEC';
            }

            //-- voorverwarming geldt OF voor het gewone systeem OF voor het aanvullende systeem. Als hij voor géén van beide geldt is relevant=false, ander true
            let relevant = showIt;
            if (!relevant) {
                //-- als voorverwarming niet relevant is voor deze ventilatiekolom, kan hij nog relevant zijn voor de andere ventilatiekolom
                let andereVentilatiekolom = _ventilatiekolommen.find(function (x) { return x.isAanvullendSysteem !== ventilatiekolom.isAanvullendSysteem; });
                propSysId = andereVentilatiekolom.isAanvullendSysteem ? 'VENTAAN_SYS' : 'VENT_SYS';
                propValueSys = andereVentilatiekolom.entdata.PropertyDatas[propSysId].Value;
                relevant = !kolomIsHidden(andereVentilatiekolom) && (propValueSys === 'VENTSYS_NAT' || propValueSys === 'VENTSYS_NATMECH') && na2010;
            }

            ntaEntityData.setEntityStatus(ventilatiekolom.voorverwarming, relevant);

            return !showIt;
        } //-- end: voorverwarmingIsHidden ------------------------------------------------------------------------//

        function warmteterugwinningIsHidden(ventilatiekolom) {
            //-- Conditie [WA] begint met Toon...
            if (!ventilatiekolom) {
                return true;
            }

            // Als het systeem hidden is, moet de hele kolom hidden zijn
            let showIt = !kolomIsHidden(ventilatiekolom);

            if (showIt) {
                const propSysId = ventilatiekolom.isAanvullendSysteem ? 'VENTAAN_SYS' : 'VENT_SYS';
                const propValueSys = ventilatiekolom.entdata.PropertyDatas[propSysId].Value;
                const sitA = propValueSys === 'VENTSYS_MECHC' || propValueSys === 'VENTSYS_MECHD' || propValueSys === 'VENTSYS_GEC';

                const propSysVarId = ventilatiekolom.isAanvullendSysteem ? 'VENTAAN_SYSVAR' : 'VENT_SYSVAR';
                const product = getSelectedProduct(propSysVarId, ventilatiekolom.entdata);
                const sitB = !!product && product.Variant.trim() !== 'D.1';

                showIt = sitA && sitB;
            }

            const entdatas = [ventilatiekolom.warmteterugwinning];

            //-- VO 2021-04-08: Als warmteterugwinning niet zichtbaar en niet relevant is, geldt dit ook voor de toevoerkanalen. Als WTW wel
            //-- zichtbaar is, zorgt het formulier voor een check of de toevoerkananalen relevant zijn.
            if (!showIt) {
                const toevoerkanalen = ventilatiekolom.warmteterugwinning.tempUnits.map(tempUnit => tempUnit.toevoerkanaal);
                entdatas.push(...toevoerkanalen);
            }

            ntaEntityData.setEntityStatus(entdatas, showIt);

            return !showIt;
        } //-- end: warmteterugwinningIsHidden ------------------------------------------------------------------------//

        function ventilatorenIsHidden(ventilatiekolom) {
            //-- Conditie FN begint met velden verbergen....
            if (!ventilatiekolom) {
                return true;
            }

            let isHidden = false;

            // Als het systeem hidden is, moet de hele kolom hidden zijn
            if (kolomIsHidden(ventilatiekolom)) {
                isHidden = true;
            } else {
                let propSysId = ventilatiekolom.isAanvullendSysteem ? 'VENTAAN_SYS' : 'VENT_SYS';

                let propValueVentSys = ventilatiekolom.entdata.PropertyDatas[propSysId].Value;
                isHidden = propValueVentSys === 'VENTSYS_NAT';
            }
            ntaEntityData.setEntityStatus(ventilatiekolom.ventilatoren, !isHidden);
            if (isHidden) {
                setRelevancyVentilatorEigenschappen(ventilatiekolom, false);
            }

            return isHidden;
        } //-- end: ventilatorenIsHidden ------------------------------------------------------------------------//

        function ventilatorEigenschappenIsHidden(ventilatiekolom) {
            //-- moet de tabel om eigenschappen voor ventilatoren zichtbaar zijn of niet.

            //-- Conditie [FG] begint met Toon...
            if (!ventilatiekolom) {
                return true;
            }

            let showIt = false;

            // Als het systeem hidden is, moet de hele kolom hidden zijn
            if (!kolomIsHidden(ventilatiekolom) && !ventilatorenIsHidden(ventilatiekolom)) {
                let propInvoerVentilatorVermogen = _ventilatorenProperties['VENTILATOR_INV'];
                let propValueInvoerVentilatorVermogen = propInvoerVentilatorVermogen.getValue(ventilatiekolom.ventilatoren);
                showIt = !isHidden(propInvoerVentilatorVermogen, ventilatiekolom.ventilatoren) && !!propValueInvoerVentilatorVermogen && propValueInvoerVentilatorVermogen !== 'VENTILATORFABR_A'
            }

            setRelevancyVentilatorEigenschappen(ventilatiekolom, showIt);

            return !showIt;
        } //-- end: ventilatorEigenschappenIsHidden ------------------------------------------------------------------------//

        function ventilatorEigenschappenUnitIsHidden(tempUnit, ventilatiekolom) {
            //-- VO 2021-05-04: de eigenschappentabel voor ventilatoren is zichtbaar, maar nu moet er per unit gecheckt worden of hij getoond mag worden of
            //-- niet. Wanneer er sprake is van een systeem voor een geheel gebouw is alleen de eerste unit zichtbaar. Wanneer het systeem per unit is
            //-- decentrale ventilatie, of niet-gemeenschappelijk of geen-luchtbehandelingskast dan moeten alle units zichtbaar zijn. Bij rekenen per gebouw is
            //-- er altijd maar één unit. Iedere unit kan meerdere ventilatoreigenschappen entiteiten hebben. (VENTILATOREIG)
            if (!tempUnit || !ventilatiekolom) {
                return true;
            }

            const hideIt = isLbkAanwezig() && ventilatiekolom.ventilatoren.tempUnits[0].EntityDataId !== tempUnit.EntityDataId;

            if (tempUnit.ventilatorEigenschappen) {
                tempUnit.ventilatorEigenschappen.forEach(function (ventilatoreigenschap) {
                    ntaEntityData.setEntityStatus(ventilatoreigenschap, !hideIt);
                });
            }

            return hideIt;
        } //-- end: ventilatorEigenschappenUnitIsHidden ------------------------------------------------------------------------//

        function ventilatiedebietenIsHidden() {
            //-- Conditie DK
            let isHidden = werkelijkGeinstalleerdeVentilatiecapaciteitIsHidden() && werkelijkGeinstalleerdeVentilatiecapaciteitTabelIsHidden() && !conditieDN();

            ntaEntityData.setEntityStatus(_ventilatiedebietData, !isHidden);

            return isHidden;
        } //-- end: ventilatiedebietenIsHidden ------------------------------------------------------------------------//

        function distributieIsHidden() {
            //-- Conditie RE
            let ventilatiesysteem = _ventData.PropertyDatas['VENT_SYS'].Value;
            let isHidden = ventilatiesysteem === 'VENTSYS_NAT'; // V03 = A

            ntaEntityData.setEntityStatus(_ventilatiedistributieData, !isHidden);

            return isHidden;
        } //-- end: distributieIsHidden ------------------------------------------------------------------------//

        function validateWarmteterugwinningProp(propName, entdata) {
            let prop = _warmteterugwinningProperties[propName];
            let propdata = prop.getData(entdata);
            if (propdata.Touched) {
                //-- Valideren om foutmelding direct te kunnen tonen
                validate(prop, propdata, entdata);
            }
        } //-- end: validateWarmteterugwinningProp ------------------------------------------------------------------------//

        function voorverwarmingInDeelToevoerroosters() {
            //-- Voorverwarming controleren
            let propAandeelVoorverwarming = _voorverwarmingProperties['VOORWARM_AAN'];
            let propValueAandeelVoorverwarming = propAandeelVoorverwarming.getValue(_voorverwarmingData);

            //-- V17 is 'voorverwarming in deel toevoerroosters'
            return ((propValueAandeelVoorverwarming === 'VOORWARMAAN_DEEL') &&
                (!voorverwarmingIsHidden(_ventilatieKolom) || !voorverwarmingIsHidden(_ventilatieAanvullendKolom)) &&
                (!isHidden(propAandeelVoorverwarming, _voorverwarmingData)));
        } //-- end: voorverwarmingInDeelToevoerroosters ------------------------------------------------------------------------//

        function setRelevancyVentilatorEigenschappen(ventilatiekolom, relevant) {
            //-- VO 2021-05-04: als de eigenschappen niet relevant zijn, kunnen alle eigenschappen meteen op false. Anders meot er gecontroleerd woreden
            //-- of de ventilatoreigenschap (VENTILATOREIG) wel zichtbaar moet zijn voor de unit.
            if (relevant) {
                for (const unit of _units) {
                    ventilatorEigenschappenUnitIsHidden(unit, ventilatiekolom);
                }
            } else {
                const ventilatoreigenschappen = (ventilatiekolom.ventilatoren.tempUnits || []).flatMap(tempUnit => tempUnit.ventilatorEigenschappen || []);
                ntaEntityData.setEntityStatus(ventilatoreigenschappen, relevant);
            }
        } //-- end: setRelevancyVentilatorEigenschappen ------------------------------------------------------------------------//

        function getAangeslotenUnits() {
            /// VENT -> RZ -> UNIT-RZ <- UNIT
            const units = ntaEntityData.getChildren(_ventData, 'RZ')
                .flatMap(rzEntdata => ntaEntityData.getChildren(rzEntdata, 'UNIT-RZ'))
                .map(unitRzEntdata => ntaEntityData.getFirstParent(unitRzEntdata, 'UNIT'));
            return ntaEntityData.distinct(units)
                .sort(ntaSharedLogic.orderElements);
        } //-- end: getAangeslotenUnits ------------------------------------------------------------------------//

        function getUnitRekenzones(unit) {
            return unit && _unitRekenzonesPerUnit[unit.EntityDataId] || [];
        }

        function getVentilatiecapaciteit(unitRz) {
            return unitRz && _ventcapPerUnitRz[unitRz.EntityDataId] || [];
        }

        function getVentilatiezwembadruimte(rz) {
            return rz && _ventzbrPerRz[rz.EntityDataId] || [];
        }

        function buildVentcapaciteitenTabel() {
            // Voor elke aangesloten unitRekenzone hebben we een VENTCAP-entiteit nodig
            const unitRekenzones = ntaEntityData.getChildren(_ventData, 'RZ')
                .flatMap(rz => ntaEntityData.getChildren(rz, 'UNIT-RZ'));

            const ventcapIds = new Set(ntaEntityData.getChildIds(_ventData, 'VENTCAP'));

            for (const unitRz of unitRekenzones) {
                const unitRzVentcapIds = ntaEntityData.getChildIds(unitRz, 'VENTCAP');
                const ventcapId = unitRzVentcapIds.find(ventcapId => ventcapIds.has(ventcapId));
                let ventcap = ntaEntityData.get(ventcapId);
                if (!ventcap) {
                    const ventcapId = ntaEntityData.create('VENTCAP', -1, [
                        { "OnCopy": 1, "OnDelete": 1, "Parent": _ventDataId, "ParentEntityId": "VENT" },
                        { "OnCopy": 1, "OnDelete": 1, "Parent": unitRz.EntityDataId, "ParentEntityId": "UNIT-RZ" }
                    ], [], null);
                    ventcap = ntaEntityData.get(ventcapId);
                }
                _ventcapPerUnitRz[unitRz.EntityDataId] = [ventcap];
            }

            const unitRekenzoneIds = new Set(unitRekenzones.map(unitRz => unitRz.EntityDataId));
            for (const unit of _units) {
                _unitRekenzonesPerUnit[unit.EntityDataId] = ntaEntityData.getChildren(unit, 'UNIT-RZ').filter(unitRz => unitRekenzoneIds.has(unitRz.EntityDataId));
            }

            // Verwijder meldingen voor alle VENTCAP-entiteiten onder dit ventilatiesysteem die horen bij een UNIT-RZ die niet meer gekoppeld is aan dit ventilatiesysteem.
            for (const ventcapId of ventcapIds) {
                const isGekoppeld = ntaEntityData.getParentIds(ventcapId, 'UNIT-RZ')
                    .some(unitRzId => unitRekenzoneIds.has(unitRzId));
                if (!isGekoppeld) {
                    const ventcap = ntaEntityData.get(ventcapId);
                    for (const propdata of ventcap && ventcap.PropertyDatas || []) {
                        ntaValidation.IsValid(ventilatieLogic.form_installationventilatie, null, propdata, true);
                    }
                }
            }

        } //-- end: buildVentcapaciteitenTabel ------------------------------------------------------------------------//

        function buildVentZwembadruimteTabel() {
            // Voor elke aangesloten rekenzone hebben we een VENTZBR-entiteit nodig
            const ventzbrs = new Set(ntaEntityData.getChildren(_ventilatiedebietData, 'VENTZBR'));

            const rekenzones = ntaEntityData.getChildren(_ventData, 'RZ');

            for (const rz of rekenzones) {
                const rzVentzbrs = ntaEntityData.getChildren(rz, 'VENTZBR');
                let ventzbr = rzVentzbrs.find(ventzbr => ventzbrs.has(ventzbr));
                if (!ventzbr) {
                    const ventzbrId = ntaEntityData.create('VENTZBR', -1, [
                        { "OnCopy": 1, "OnDelete": 1, "Parent": _ventilatiedebietData.EntityDataId, "ParentEntityId": _ventilatiedebietData.EntityId },
                        { "OnCopy": 1, "OnDelete": 1, "Parent": rz.EntityDataId, "ParentEntityId": rz.EntityId },
                    ], [], null);
                    ventzbr = ntaEntityData.get(ventzbrId);
                }
                _ventzbrPerRz[rz.EntityDataId] = [ventzbr];
            }

            const rekenzoneIds = new Set(rekenzones.map(rz => rz.EntityDataId));

            // Voor alle VENTZBR-entiteiten onder dit ventilatiesysteem die horen bij een RZ die niet meer gekoppeld is aan dit ventilatiesysteem:
            // Verwijder meldingen
            // Maak properties niet relevant

            for (const ventzbr of ventzbrs) {
                const isGekoppeld = ntaEntityData.getParentIds(ventzbr, 'RZ')
                    .some(rzId => rekenzoneIds.has(rzId));
                if (!isGekoppeld) {
                    const propdatas = ventzbr && ventzbr.PropertyDatas || [];
                    ntaEntityData.setPropdataStatus(propdatas, false, false);
                    for (const propdata of propdatas) {
                        ntaValidation.IsValid(ventilatieLogic.form_installationventilatie, null, propdata, true);
                    }
                }
            }

        } //-- end: buildVentzwembadruimteTabel ------------------------------------------------------------------------//

        function createTempEntityObject(entity) {
            //-- Maakt nieuw object voor een gegeven entiteit. Dit nieuwe object kan tijdelijk worden gebruikt en staat niet in de data van ntabuilding (PropertyDatas zijn nog wel dezelfde).
            return {
                PropertyDatas: entity.PropertyDatas,
                EntityDataId: entity.EntityDataId,
                EntityId: entity.EntityId,
                Order: entity.Order
            };
        } //-- end: createTempEntityObject -----------------------------------------------------------------------//

        function conditieSB() {
            // [SB] veld alleen tonen als V05=E. gecombineerde systemen
            return _ventData.PropertyDatas['VENT_SYS'].Value === 'VENTSYS_GEC';
        } //-- end: conditieSB --------------------------------------------------------------------

        function conditieSX() {
            // [SX] toon als G04=appartementengebouw / utiliteitsgebouw EN Z23=per gebouw en per appartement/unit. Toon ook als Z23='voor projectwoningen'
            return ntaSharedLogic.perGebouwEnAppartementOfUnit() || ntaSharedLogic.voorProjectwoningen();
        } //-- end: conditieSX --------------------------------------------------------------------

        function conditieSW() {
            // [SW] verberg als G04=appartementengebouw / utiliteitsgebouw EN Z23=per gebouw en per appartement/unit. Verberg ook als Z23 = ' voor projectwoningen'
            return !conditieSX();
        } //-- end: conditieSW --------------------------------------------------------------------

        function setVerblijfsgebiedVentPerUnit(systeem) {
            const tempUnits = [];
            systeem.tempUnits = tempUnits;

            // Condities [SB] en [SX]
            const kolom = _ventilatiekolommen.find(vk => vk.entdata === systeem);
            const relevant = !kolomIsHidden(kolom) && conditieSB() && conditieSX();

            //-- Haal de Id op van alle verblijfsgebieden die aan deze ventilatiesysteem-entiteit zijn gekoppeld
            const verblijfsgebiedIdsVent = new Set(ntaEntityData.getChildIds(systeem, 'VENT-VERB'));

            //-- Koppel een verblijfsgebied aan elke unit of maak een nieuw verblijfsgebied aan als dit nog niet bestaat
            for (const unit of _units) {
                //-- Haal de Id op van alle verblijfsgebieden die aan deze unit-entiteit zijn gekoppeld
                const verblijfsgebiedIdsUnit = ntaEntityData.getChildIds(unit, 'VENT-VERB');

                //-- Zoek het verblijfsgebied dat in beide lijsten voorkomt
                const verblijfsgebiedId = verblijfsgebiedIdsUnit.find(vgid => verblijfsgebiedIdsVent.has(vgid));
                let verblijfsgebied = ntaEntityData.get(verblijfsgebiedId);

                //-- maak een nieuw verblijfsgebied aan als dit nog niet bestond
                if (!verblijfsgebied) {
                    const newId = ntaEntityData.create("VENT-VERB", -1, [
                        { "OnCopy": 1, "OnDelete": 1, "Parent": unit.EntityDataId, "ParentEntityId": "UNIT" },
                        { "OnCopy": 1, "OnDelete": 1, "Parent": systeem.EntityDataId, "ParentEntityId": systeem.EntityId }
                    ], [], []);
                    verblijfsgebied = ntaEntityData.get(newId);
                }
                ntaEntityData.setEntityStatus(verblijfsgebied, relevant);

                //-- Maak tempUnit
                const tempUnit = createTempEntityObject(unit);
                tempUnits.push(tempUnit);

                //-- Koppel verblijfsgebied aan unit
                tempUnit.verblijfsgebied = verblijfsgebied;
            }

            //niet gekoppelde verblijfsgebieden op niet relevant zetten.
            const gekoppeldeIds = new Set(tempUnits.map(x => x.verblijfsgebied.EntityDataId));
            const nietGekoppeldeGebieden = [...verblijfsgebiedIdsVent]
                .filter(id => !gekoppeldeIds.has(id))
                .map(id => ntaEntityData.get(id));
            ntaEntityData.setEntityStatus(nietGekoppeldeGebieden, false);
        } //-- end: setVerblijfsgebiedVentPerUnit ------------------------------------------------------------------------//

        function setToevoerkanaalNaarWTWLengtePerUnit(warmteterugwinning) {

            const tempUnits = [];
            warmteterugwinning.tempUnits = tempUnits;

            //-- Haal alle toevoerkanalen op die aan deze warmteterugwinning entiteit zijn gekoppeld
            const ventToevoerkanaalIds = new Set(ntaEntityData.getChildIds(warmteterugwinning, 'WARMTE-TOEV-KAN'));
            for (const unit of _units) {
                //-- Haal alle toevoerkanalen op die aan deze unit entiteit zijn gekoppeld
                const unitToevoerkanaalIds = ntaEntityData.getChildIds(unit, 'WARMTE-TOEV-KAN');

                //-- Zoek het toevoerkanaal die in beide lijsten voorkomt
                const toevoerkanaalId = unitToevoerkanaalIds.find(id => ventToevoerkanaalIds.has(id));
                let toevoerkanaal = ntaEntityData.get(toevoerkanaalId);

                //-- Maak een nieuw toevoerkanaal aan als deze nog niet bestond
                if (!toevoerkanaal) {
                    const parentRels = [
                        { "OnCopy": 1, "OnDelete": 1, "Parent": unit.EntityDataId, "ParentEntityId": unit.EntityId },
                        { "OnCopy": 1, "OnDelete": 1, "Parent": warmteterugwinning.EntityDataId, "ParentEntityId": warmteterugwinning.EntityId }
                    ];
                    const newId = ntaEntityData.create("WARMTE-TOEV-KAN", -1, parentRels, [], []);
                    toevoerkanaal = ntaEntityData.get(newId);
                }


                //-- Maak tempUnit
                const tempUnit = createTempEntityObject(unit);
                tempUnits.push(tempUnit);

                //-- Koppel toevoerkanaal aan unit
                tempUnit.toevoerkanaal = toevoerkanaal;
            }

            //-- nu nog de toevoerkanalen van andere units die horen bij deze wtw op relevant=false zetten
            const allUnits = ntaEntityData.getListWithEntityId('UNIT');
            allUnits.forEach(function (unit) {
                //-- Als een unit niet in de lijst voorkomt van tempUnits gekoppeld aan een ventilator, moet deze unit geen ventilatoreigenschappen hebben samen met deze ventilator
                if (!warmteterugwinning.tempUnits.find(function (x) { return x.EntityDataId === unit.EntityDataId; })) {
                    //-- Haal alle toevoerkanalen op die aan deze unit entiteit zijn gekoppeld
                    const unitToevoerkanaalIds = ntaEntityData.getChildIds(unit, 'WARMTE-TOEV-KAN');
                    //-- Zoek het toevoerkanaal die in beide lijsten voorkomt
                    const toevoerkanaalId = unitToevoerkanaalIds.find(id => ventToevoerkanaalIds.has(id));
                    const toevoerkanaal = ntaEntityData.get(toevoerkanaalId);
                    if (toevoerkanaal) {
                        //-- relevantie van dit kanaal op false zetten
                        ntaEntityData.setEntityStatus(toevoerkanaal, false);
                    }
                }
            });

        } //-- end: setToevoerkanaalNaarWTWLengtePerUnit ------------------------------------------------------------------------//

        function setVentilatorenEigenschappenPerUnit(ventilator) {
            ventilator.tempUnits = [];
            const ventilatorChildren = new Set(ntaEntityData.getChildren(ventilator, 'VENTILATOREIG'));
            const assignedChildren = new Set();

            for (const unit of _units) {
                const unitChildren = ntaEntityData.getChildren(unit, 'VENTILATOREIG');
                const ventilatoreigenschappen = unitChildren.filter(ed => ventilatorChildren.has(ed));

                //-- Maak tempUnit
                const tempUnit = createTempEntityObject(unit);
                ventilator.tempUnits.push(tempUnit);

                //-- Koppel ventilatoreigenschappen aan tempUnit of maak een nieuwe als er nog geen bestond
                if (ventilatoreigenschappen.length === 0) {
                    const newId = ntaEntityData.create("VENTILATOREIG", -1, [
                        { "OnCopy": 1, "OnDelete": 1, "Parent": tempUnit.EntityDataId, "ParentEntityId": "UNIT" },
                        { "OnCopy": 1, "OnDelete": 1, "Parent": ventilator.EntityDataId, "ParentEntityId": ventilator.EntityId }
                    ], [], []);
                    const ventilatoreigenschappenED = ntaEntityData.get(newId);
                    ventilatoreigenschappen.push(ventilatoreigenschappenED);
                }
                tempUnit.ventilatorEigenschappen = ventilatoreigenschappen;

                for (const ventilatoreigenschap of ventilatoreigenschappen) {
                    assignedChildren.add(ventilatoreigenschap);
                }
            }

            //-- verwijder de ventilatoreigenschappen van deze ventilator die niet gekoppeld zijn aan een unit
            for (const child of ventilatorChildren) {
                if (!assignedChildren.has(child)) {
                    ntaEntityData.delete(child.EntityDataId);
                }
            }

            //-- nu nog de overbodige ventilatoren eigenschappen verwijderen
            const allUnits = ntaEntityData.getListWithEntityId('UNIT');


            for (const unit of allUnits) {
                // Als een unit niet in de lijst voorkomt van tempUnits gekoppeld aan een ventilator, moet deze unit geen ventilatoreigenschappen hebben samen met deze ventilator
                if (!ventilator.tempUnits.some(x => x.EntityDataId === unit.EntityDataId)) {
                    const ventilatoreigenschappen = ntaEntityData.getChildren(ventilator, 'VENTILATOREIG').filter(ed => ntaSharedLogic.hasRelation(unit, ed));

                    // Verwijder ventilatoreigenschappen als deze bestaan
                    for (const ventilatoreigenschap of ventilatoreigenschappen) {
                        ntaEntityData.delete(ventilatoreigenschap.EntityDataId);
                    }
                }
            }
        } //-- end: setVentilatorenEigenschappenPerUnit ------------------------------------------------------------------------//

        function setDefaultValueInvoerVentilatiesysteem() {
            let propDataVentInvoer = _ventData.PropertyDatas['VENT_INVOER'];
            let propDataVentaanvullendInvoer = _ventAanvullendData.PropertyDatas['VENTAAN_INVOER'];

            if (!propDataVentInvoer.Touched) {
                if (!ntaSharedLogic.isUtiliteit()) {
                    propDataVentInvoer.Value = 'VENT_PROD';
                }
                else {
                    propDataVentInvoer.Value = 'VENT_FORF';
                }
            }
            if (!propDataVentaanvullendInvoer.Touched) {
                if (!ntaSharedLogic.isUtiliteit()) {
                    propDataVentaanvullendInvoer.Value = 'VENT_PROD';
                }
                else {
                    propDataVentaanvullendInvoer.Value = 'VENT_FORF';
                }
            }
        } //-- end: setDefaultValueInvoerVentilatiesysteem ------------------------------------------------------------------------//

        function determineFabricagejaar() {
            let jaar = ntaSharedLogic.getBouwjaar();
            let defaultValue = '';

            if (jaar < 1981) {
                defaultValue = 'WARMTEFABR_OUD';
            }
            else if (jaar < 1986) {
                defaultValue = 'WARMTEFABR_1981';
            }
            else if (jaar < 1991) {
                defaultValue = 'WARMTEFABR_1986';
            }
            else if (jaar < 1999) {
                defaultValue = 'WARMTEFABR_1991';
            }
            else if (jaar < 2007) {
                defaultValue = 'WARMTEFABR_1999';
            }
            else if (jaar < 2010) {
                defaultValue = 'WARMTEFABR_2007';
            }
            else if (jaar >= 2010) {
                defaultValue = 'WARMTEFABR_NIEUW';
            }
            else {
                defaultValue = 'WARMTEFABR_ONB';
            }

            return defaultValue;
        } //-- end: determineFabricagejaar ------------------------------------------------------------------------//

        function setDefaultValueFabricagejaar() {
            let propDataWarmteFabricagejaar = _warmteterugwinningData.PropertyDatas['WARMTETERUG_FABR'];
            let propDataWarmteAanvullendFabricagejaar = _warmteterugwinningAanvullendData.PropertyDatas['WARMTETERUG_FABR'];
            let propDataVentilatorFabricagejaar = _ventilatorenData.PropertyDatas['VENTILATOR_FABR'];
            let propDataVentilatoraanvullendFabricagejaar = _ventilatorenAanvullendData.PropertyDatas['VENTILATOR_FABR'];

            if (!propDataWarmteFabricagejaar.Touched) {
                propDataWarmteFabricagejaar.Value = determineFabricagejaar();
            }
            if (!propDataWarmteAanvullendFabricagejaar.Touched) {
                propDataWarmteAanvullendFabricagejaar.Value = determineFabricagejaar();
            }
            if (!propDataVentilatorFabricagejaar.Touched) {
                propDataVentilatorFabricagejaar.Value = determineFabricagejaar();
            }
            if (!propDataVentilatoraanvullendFabricagejaar.Touched) {
                propDataVentilatoraanvullendFabricagejaar.Value = determineFabricagejaar();
            }
        } //-- end: setDefaultValueFabricagejaar ------------------------------------------------------------------------//

        function setDefaultRendementWarmteterugwinning(ventilatiekolom) {
            const propIdInvoer = ventilatiekolom.isAanvullendSysteem ? 'VENTAAN_INVOER' : 'VENT_INVOER' // V11 of V05
            const ventInvoer = ventilatiekolom.entdata.PropertyDatas[propIdInvoer].Value;

            if (!ventInvoer) {
                //-- er is nog geen type invoer gekozen
                return;
            }

            const propRendement = _warmteterugwinningProperties['WARMTETERUG_REND']; // V24
            const propdataRendement = propRendement.getData(ventilatiekolom.warmteterugwinning);

            const propWtwInvoer = ntabuilding.properties['WARMTETERUG_INV']; // V95
            if (propWtwInvoer) {
                // Conditie [WC] vanaf de versies horend bij release 3.4 (als veld V95 bestaat):
                // indien V05 ='productspecifiek' (kolom 1) of V11='productspecifiek' (kolom 2) EN waarde tabel VE_model kolom eta_hr ≠ 0 vul veld met waarde uit kolom eta_hr
                // indien V95 ='productspecifiek' waarde tabel VE_model kolom eta_hr corresponderend met invoer veld V96;
                // indien V95 = forfaitair toon waarde table11-18 kolom eta_hr corresponderend met invoer veld V23;
                // indien V95 ≠ forfaitair / producspecifiek: leeg (invoerveld);
                //
                //indien de waarde wordt ingevuld uit tabel VE_model of table11-18 kan de gebruiker de waarde niet meer wijzigen.

                let initialEtaHr = '';
                if (!isHidden(propWtwInvoer, ventilatiekolom.warmteterugwinning)) {
                    const wtwInvoer = propWtwInvoer.getValue(ventilatiekolom.warmteterugwinning);
                    switch (wtwInvoer) {
                        case 'WTWINV_FORF': {
                            const wtwType = ventilatiekolom.warmteterugwinning.PropertyDatas['WARMTETERUG_TYPE'].Value; // V23
                            initialEtaHr = _warmteterugwinningTypes.find(cv => cv.Id === wtwType)?.eta_hr ?? '';
                            break;
                        }
                        case 'WTWINV_PROD': {
                            const product = getSelectedProduct('WARMTETERUG_TYPE_PRDT', ventilatiekolom.warmteterugwinning); // V96
                            initialEtaHr = ntaRounding.roundAndAddZerosNewValue(propRendement, product?.eta_hr || 0);
                            break;
                        }
                    }
                }
                if (!initialEtaHr && ventInvoer === 'VENT_PROD') {
                    const propIdVariant = ventilatiekolom.isAanvullendSysteem ? 'VENTAAN_SYSVAR' : 'VENT_SYSVAR';
                    const product = getSelectedProduct(propIdVariant, ventilatiekolom.entdata);
                    if (product && product.eta_hr !== null) {
                        initialEtaHr = ntaRounding.roundAndAddZerosNewValue(propRendement, product.eta_hr || 0);
                    }
                }
                if (initialEtaHr || !propdataRendement.Touched) {
                    saveValue(propRendement, ventilatiekolom.warmteterugwinning, initialEtaHr);
                }

            } else {

                // Als veld V95 niet bestaat, zitten we in een vergrendelde berekening van vóór de release van versie 3.4.
                // Dan de oude conditie gebruiken:
                // [WC] indien V23='WTW rendement volgens NEN-EN13141-7, NEN-EN13141-8' (table11-18 ID 11)
                //              of 'WTW rendement volgens NEN-EN13142' (table11-18 ID 12)
                //              of WTW rendement volgens NEN-EN 13053 (ID 14):
                //      => leeg(invoerveld);
                //      indien V23≠'WTW rendement volgens EN13141-7, EN13141-8' (table11-18 ID 11)
                //              of 'WTW rendement volgens EN13142' (table11-18 ID 12):
                //      => waarde table11-18 kolom eta_hr corresponderend met invoer veld V23;
                //      indien V05='productspecifiek' (kolom 1)
                //          of V11='productspecifiek' (kolom 2):
                //      => waarde tabel VE_model kolom eta_hr corresponderend met invoer veld V06 (kolom 1) en/of V12 (kolom 2);
                // indien de waarde wordt ingevuld uit tabel VE_model of table11-18 kan de gebruiker de waarde niet meer wijzigen.

                if (ventInvoer === 'VENT_PROD') {
                    //-- set eta_hr op basis van product
                    const propVariantId = ventilatiekolom.isAanvullendSysteem ? 'VENTAAN_SYSVAR' : 'VENT_SYSVAR';
                    const product = getSelectedProduct(propVariantId, ventilatiekolom.entdata);
                    if (product) {
                        const newEta_hr = ntaRounding.roundAndAddZerosNewValue(propRendement, product.eta_hr || 0);
                        saveValue(propRendement, ventilatiekolom.warmteterugwinning, newEta_hr);
                    }
                } else {
                    // set eta_hr op basis van table11_18
                    const wtwType = ventilatiekolom.warmteterugwinning.PropertyDatas['WARMTETERUG_TYPE'].Value; // V23
                    let newEta_hr = _warmteterugwinningTypes.find(x => x.Id === wtwType)?.eta_hr;
                    if (newEta_hr !== '') {
                        newEta_hr = ntaRounding.roundAndAddZerosNewValue(propRendement, newEta_hr);
                        saveValue(propRendement, ventilatiekolom.warmteterugwinning, newEta_hr);
                    } else if (!propdataRendement.Touched) {
                        saveValue(propRendement, ventilatiekolom.warmteterugwinning, '');
                    }
                }
            }
        } //-- end: setDefaultRendementWarmteterugwinning ------------------------------------------------------------------------//

        function setDefaultBypassAandeel(ventilatiekolom) {
            // [WI] indien V26='eigen waarde': leeg (invoerparameter);
            //      indien V26≠'eigen waarde' en WN/WB en V27≠'2010 en nieuwer' dan waarde uit table-bypass kolom EtaBypassW<2010,
            //      indien V26≠'eigen waarde' en WN/WB en V27='2010 en nieuwer' dan kolom EtaBypassW>=2010,
            //      indien V26≠'eigen waarde' en UN/UB dan kolom EtaBypassU
            //      indien V26 verborgen veld dan waarde uit tabel VE_model kolom eta_bypass corresponderend met invoer veld V06 of V96 (kolom 1) en/of V12 of V96 (kolom 2);
            //      indien de waarde wordt ingevuld uit tabel VE_model of table-bypass kan de gebruiker de waarde niet meer wijzigen.

            const propBypass = _warmteterugwinningProperties['WARMTETERUG_BYP'];            // V26
            const propBypassAandeel = _warmteterugwinningProperties['WAMRTETERUG_BYPA'];    // V28

            const wtw = ventilatiekolom.warmteterugwinning;

            const propValueBypass = propBypass.getValue(wtw);
            if (propValueBypass === null) {
                return;
            }

            if (isHidden(propBypass, wtw)) { // VE_model
                //-- als bypass niet zichtbaar is moet het aandeel uit de selectietabel komen
                const product = getMatchingProduct(ventilatiekolom, p => p.eta_bypass !== null);
                if (product) {
                    const newEta_bypass = ntaRounding.roundAndAddZerosNewValue(propBypassAandeel, product.eta_bypass || 0);
                    saveValue(propBypassAandeel, wtw, newEta_bypass);

                    //-- ook de wijze van bypass moet gezet worden naar eigen waarde, zodat de juiste bypass mee gaat naar de rekenkern. Dit
                    //-- geldt alleen voor de 3.1 projecten. Projecten van 3.0 moeten met de oude resultaten blijven rekenen, ondanks dat de TOjuli
                    //-- dan niet klopt.
                    if (ntabuilding.appVersionId >= 100) {
                        saveValue(propBypass, wtw, 'WERMTEBYP_EIG')
                    }
                }
            } else if (propValueBypass !== 'WERMTEBYP_EIG') {
                //-- de spelfout WERMTEBYP_EIG staat ook zo in de metadata als CodedValueId. Deze fout aanpassen zou betekenen dat er een global upgrader geschreven moet worden
                //-- en daar zien we even vanaf.
                const bypassType = _bypassTypes.find(x => x.Id === propValueBypass);
                let newEta_bypass;
                if (ntaSharedLogic.isUtiliteit()) { // EtaBypassU
                    newEta_bypass = bypassType.EtaBypassU;
                } else {
                    const propValueFabricagejaar = wtw.PropertyDatas['WARMTETERUG_FABR'].Value;

                    newEta_bypass = propValueFabricagejaar === 'WARMTEFABR_NIEUW'
                        ? bypassType.EtaBypassWGR2010
                        : bypassType.EtaBypassWKL2010;
                }
                newEta_bypass = ntaRounding.roundAndAddZerosNewValue(propBypassAandeel, newEta_bypass);
                saveValue(propBypassAandeel, wtw, newEta_bypass);
            }
        } //-- end: setDefaultBypassAandeel ------------------------------------------------------------------------//

        function isReadOnly(prop, entdata) {
            if (!prop || !entdata || entdata.BuildingId !== ntabuilding.buildingId) {
                return false;
            }

            switch (prop.Id) {
                case 'VENT_VARIANT':
                case 'VENTAAN_VARIANT':
                case 'WARMTETERUG_SYS':
                case 'VENTILATOR_PNC':
                case 'VENTILATOR_FREGB':
                case 'VENTILATOR_PNOM1':
                case 'VENTILATOR_PNOM2':
                case 'VENTILATOR_PNOM3':
                case 'VENTILATOREIG_PNA':
                case 'MEASURE-COSTS_SUBS_TOTAAL':
                case 'MEASURE-COSTS_TOTAAL':
                    {
                        return true;
                    }
                case 'VENT_FCTRL':
                case 'VENTAAN_FCTRL':
                    {
                        let propInvoerId = entdata.EntityId === 'VENT' ? 'VENT_INVOER' : 'VENTAAN_INVOER';
                        let propValueInvoer = entdata.PropertyDatas[propInvoerId].Value;
                        return propValueInvoer !== 'VENT_EIG';
                    }
                case 'VOORWARM_MAXV':
                case 'VOORWARM_MAXT':
                case 'VOORWARM_BUIT':
                case 'VOORWARM_MAXI':
                    {
                        let propValueVoorwNatToev = entdata.PropertyDatas['VOORWARM_NT'].Value;
                        return propValueVoorwNatToev === 'VOORWARMNT_PROD'
                    }
                case 'WARMTETERUG_REND':
                    {
                        // [WC] indien de waarde wordt ingevuld vanuit VE_model of table11-18 kan de gebruiker de waarde niet wijzigen

                        const ventilatiekolom = _ventilatiekolommen.find(vk => vk.warmteterugwinning.EntityDataId === entdata.EntityDataId);
                        const product = getMatchingProduct(ventilatiekolom, p => p.eta_hr !== null);
                        if (product) return true;

                        const propdataWtwInvoer = entdata.PropertyDatas['WARMTETERUG_INV']; // V95
                        if (propdataWtwInvoer) {
                            // vanaf de versies horend bij release 3.4 (als veld V95 bestaat)
                            return propdataWtwInvoer.Visible && ['WTWINV_FORF', 'WTWINV_PROD'].includes(propdataWtwInvoer.Value);
                        } else {
                            // oude conditie
                            const propdataWtwType = entdata.PropertyDatas['WARMTETERUG_TYPE']; // V23
                            return !propdataWtwType.Visible
                                || !['WARMTETYPE_REN1', 'WARMTETYPE_REN2', 'WARMTETYPE_REN3'].includes(propdataWtwType.Value);
                        }
                    }
                case 'WAMRTETERUG_BYPA':
                    {
                        // Conditie [WI] indien de waarde wordt ingevuld uit tabel VE_model of table-bypass kan de gebruiker de waarde niet meer wijzigen.
                        const propBypass = _warmteterugwinningProperties['WARMTETERUG_BYP']; // V26
                        const propValueBypass = propBypass.getValue(entdata);
                        return propValueBypass !== 'WERMTEBYP_EIG'
                            || isHidden(propBypass, entdata);
                    }
                case 'VENTILATOREIG_FREG':
                    {
                        const ventilatoren = ntaEntityData.getFirstParent(entdata, 'VENTILATOR');
                        return !!ventilatoren && ventilatoren.PropertyDatas['VENTILATOR_INV'].Value !== 'VENTILATORFABR_C';
                    }
                case 'VENTCAP_ND':
                case 'VENTCAP_NV':
                case 'VENTCAP_NAOS':
                case 'VENTCAP_MD':
                case 'VENTCAP_MV':
                    {
                        //Conditie [DP] als versie = ge3-2 EN V89 voor de betreffende rekenzone is aangevinkt dan regel uitgrijzen en geef bij invulvelden 'n.v.t.' aan (Niet aan te passen door gebruiker)
                        if (ntabuilding.ntaVersionId >= 200) {
                            const zbrProp = _ventzwembadruimteProperties['VENTZBR_AANW'];
                            const unitRz = ntaEntityData.getFirstParent(entdata, 'UNIT-RZ');
                            const rz = ntaEntityData.getFirstParent(unitRz, 'RZ');
                            const ventZbr = ntaEntityData.getFirstChild(rz, 'VENTZBR');
                            const propdata = zbrProp.getData(ventZbr);
                            return propdata.Relevant && propdata.Value === 'True';
                        } else return false;
                    }
                case 'VENTZBR_AG':
                    {
                        const zbrProp = _ventzwembadruimteProperties['VENTZBR_AANW'];
                        const propdata = zbrProp.getData(entdata);
                        return propdata.Relevant && propdata.Value === 'False';
                    }
                default:
                    return false;
            }
        } //-- end: isReadOnly ------------------------------------------------------------------------//

        function getCodedValues(prop, entdata) {
            let typesList = [];

            if (!prop || !entdata || entdata.BuildingId !== ntabuilding.buildingId) {
                return typesList;
            }

            switch (prop.Id) {
                case 'VENT_PKOEL': { // V72
                    typesList = ntaValidation.codedValues(prop);

                    const product = getSelectedProduct('VENT_SYSVAR', entdata);

                    /// conditie [RH] verberg als waarde in kolom 'passieve_koeling' van VE_model behorend bij het model gekozen in V07 = 'ja'
                    if (product && product.PassieveKoeling) {
                        typesList = typesList.filter(cv => cv.Id !== 'VENTDIS_PKOEL_GEEN');
                    }
                    /// [RI] indien ge3-3: verberg als certificate van VE_model ≠ F EN waarde in kolom 'passieve_koeling'
                    /// van VE_model behorend bij het model gekozen in V07 = 'nee' of 'leeg'(keuze 'geen passieve koelregeling'
                    /// tonen en vastzetten)
                    if (ntabuilding.appVersionId >= 300 && product?.Certificate && !product?.PassieveKoeling) {
                        typesList = typesList.filter(cv => cv.Id == 'VENTDIS_PKOEL_GEEN');
                    }

                    break;
                }
                case 'VENTDIS_LBK':// V69
                    {
                        typesList = ntaValidation.codedValues(prop, 'D', false);
                        break;
                    }
                case 'VENT_INVOER': // V05
                case 'VENTAAN_INVOER': // V11
                    {
                        let propSysId = entdata.EntityId === 'VENT' ? 'VENT_SYS' : 'VENTAAN_SYS';
                        let propValueSys = entdata.PropertyDatas[propSysId].Value;

                        typesList = ntaValidation.codedValues(prop);
                        if (propValueSys === 'VENTSYS_NAT' || propValueSys === 'VENTSYS_MECH') {
                            typesList = ntaValidation.codedValues(prop, 'AB', true);
                        }
                        break;
                    }
                case 'VENTDEB_CAP': // V55
                    {
                        typesList = ntaValidation.codedValues(prop);

                        // Conditie DL
                        let propAandeelVoorverwarming = _voorverwarmingProperties['VOORWARM_AAN'];
                        let propValueAandeelVoorverwarming = propAandeelVoorverwarming.getValue(_voorverwarmingData);

                        if (propValueAandeelVoorverwarming === 'VOORWARMAAN_DEEL' && (!voorverwarmingIsHidden(_ventilatieKolom) || !voorverwarmingIsHidden(_ventilatieAanvullendKolom)) && !isHidden(propAandeelVoorverwarming, _voorverwarmingData)) {
                            //-- V17 is 'voorverwarming in deel toevoerroosters'
                            typesList = typesList.filter(function (x) { return x.Id !== 'VENTDEBCAP_ONB'; });
                        }

                        break;
                    }
                case 'WARMTETERUG_TYPE': { // V23
                    typesList = _warmteterugwinningTypes;

                    // Als veld V95 bestaat, dan de ‘eigen waarde’ opties niet tonen (die zijn aldaar beschikbaar)
                    const propWtwInvoer = ntabuilding.properties['WARMTETERUG_INV']; // V95
                    if (propWtwInvoer) {
                        // toon kolom 'description' in 'table11-18' [WM] met uitzondering van ID's 11, 12 en 14
                        const eigenWaardeIds = new Set(['WARMTETYPE_REN1', 'WARMTETYPE_REN2', 'WARMTETYPE_REN3']); // table11-18 id’s 11, 12, 14
                        typesList = typesList.filter(x => !eigenWaardeIds.has(x.Id));
                    }

                    // Conditie [WM]
                    let product;
                    if (ntaSharedLogic.hasRelation(_ventData, entdata)) {
                        product = getSelectedProduct('VENT_SYSVAR', _ventData);
                    } else if (ntaSharedLogic.hasRelation(_ventAanvullendData, entdata)) {
                        product = getSelectedProduct('VENTAAN_SYSVAR', _ventAanvullendData);
                    }
                    if (!product || !['D.1', 'D.4a', 'D.4b', 'D.5a'].includes(product.Variant.trim())) {
                        typesList = typesList.filter(x => x.Id !== 'WARMTETYPE_GEEN');
                    }
                    break;
                }
                case 'WARMTETERUG_BYP': { // V26
                    typesList = _bypassTypes;
                    break;
                }
                case 'WARMTETERUG_WTW': { // V85
                    typesList = ntaValidation.codedValues(prop);

                    // Conditie [WP]
                    const ventilatiekolom = _ventilatiekolommen.find(vk => vk.warmteterugwinning.EntityDataId === entdata.EntityDataId)
                    if (ventilatiekolom) {
                        const product = getMatchingProduct(ventilatiekolom, p => p.KoudeTerugwinning);
                        if (product) {
                            typesList = typesList.filter(x => x.Id !== 'WARMTETERUG_WTW_NIET');
                        }
                    }

                    break;
                }
                case 'VENTAAN_SYS': { // V09
                    typesList = ntaValidation.codedValues(prop);
                    //-- bij deze property moet het item  verwijderd worden.
                    typesList = typesList.filter(cv => cv.Id !== 'VENTSYS_GEC');
                    break;
                }
                case 'VENTILATOR_TYPE': { // V37
                    typesList = ntaValidation.codedValues(prop);
                    // Conditie [FR]
                    const propFabricagejaar = _ventilatorenProperties['VENTILATOR_FABR'];
                    const fabricagejaar = propFabricagejaar.getValue(entdata);
                    if (fabricagejaar === 'WARMTEFABR_2007' || fabricagejaar === 'WARMTEFABR_NIEUW') {
                        typesList = typesList.filter(cv => cv.Id !== 'VENTILATORTYPE_WIS' && cv.Id !== 'VENTILATORTYPE_ONBEK');
                    }
                    break;
                }
                case 'WARMTETERUG_FABR':  // V27
                case 'VENTILATOR_FABR': { // V36
                    typesList = ntaValidation.codedValues(prop);

                    /// Conditie [FS] toon alleen de fabricagejaren die relevant zijn voor het gekozen bouwjaar (G06). Dit hoeft alleen
                    /// voor versie ge3-4.
                    if (ntabuilding.appVersionId >= 400) {
                        const bouwjaar = ntaSharedLogic.getBouwjaar();
                        typesList = typesList.filter(cv => cv.FilterValue1 >= bouwjaar);
                        /// nu nog controleren of de waarde die eventueel al in propdata zit nog steeds in de lijst zit,
                        /// anders de defaultbouwjaar obv G06 opnieuw bepalen.
                        if (!getListItem(prop, entdata, typesList)) {
                            const propdata = prop.getData(entdata);
                            propdata.Value = determineFabricagejaar();
                        }
                    }
                    break;
                }
                default: {
                    typesList = ntaValidation.codedValues(prop);
                    break;
                }
            }

            ntaSharedLogic.checkPropdataInList(prop, entdata, typesList, ventilatieLogic);
            return typesList;
        } //-- end: getCodedValues ------------------------------------------------------------------------//

        function validateDependencies(prop, entdata) {
            //-- Ontvangt via de dependencyValidator (die aangeroepen wordt na de saveValue) het veld waarvoor interne afhankelijkheden gelden
            if (!prop || !entdata) {
                return;
            }

            switch (prop.Id) {
                case 'VENT_SYSVAR':
                case 'VENTAAN_SYSVAR':
                    {
                        let ventilatiekolom = _ventilatieKolom;
                        if (entdata.Entity === 'VENTAAN') {
                            ventilatiekolom = _ventilatieAanvullendKolom;
                        }
                        setValuesDependingOnSelectionTable();
                        setDescriptionInstallation(ventilatiekolom.entdata);
                        setDefaultBypassAandeel(ventilatiekolom);

                        isHidden('WARMTETERUG_WTW', ventilatiekolom.warmteterugwinning);
                        break;
                    }
                case 'VENT_SYS':
                case 'VENT_ZRR':
                case 'VENT_ZRR_TYPE':
                case 'VENT_INVOER':
                case 'VENTAAN_SYS':
                case 'VENTAAN_ZRR':
                case 'VENTAAN_ZRR_TYPE':
                case 'VENTAAN_INVOER':
                    {
                        let propSysId = 'VENT_SYS';
                        let propSysVarId = 'VENT_SYSVAR';
                        let properties = _ventProperties;
                        let ventilatiekolom = _ventilatieKolom;
                        if (entdata.EntityId === 'VENTAAN') {
                            propSysId = 'VENTAAN_SYS';
                            propSysVarId = 'VENTAAN_SYSVAR';
                            properties = _ventAanvullendProperties;
                            ventilatiekolom = _ventilatieAanvullendKolom;
                        }

                        const propSys = properties[propSysId];
                        const propValueSys = propSys.getValue(entdata);
                        const propSysVar = properties[propSysVarId];

                        getSelectionTable(propSysVar, entdata); //-- deze filtert de juiste waarden voor de selectietabel en valideert of de value van het product nog voor komt in de lijst. Anders wordt het product op null gezet.
                        setValuesDependingOnSelectionTable();

                        setDefaultRendementWarmteterugwinning(ventilatiekolom);

                        //-- nog checks specifiek bij het wijzigen van het type systeem
                        if (prop.Id === 'VENT_SYS' || prop.Id === 'VENTAAN_SYS') {
                            const propValueSysteem = _ventData.PropertyDatas['VENT_SYS'].Value;
                            const propValueSysteemAanvullend = _ventAanvullendData.PropertyDatas['VENTAAN_SYS'].Value;
                            if (propValueSysteem && propValueSysteem !== 'VENTSYS_NAT' && propValueSysteem !== 'VENTSYS_NATMECH') {
                                if (propValueSysteem === 'VENTSYS_GEC' && propValueSysteemAanvullend && propValueSysteemAanvullend !== 'VENTSYS_NAT' && propValueSysteemAanvullend !== 'VENTSYS_NATMECH') {
                                    saveValue('VOORWARM_NT', _voorverwarmingData, 'VOORWARMNT_GEEN');
                                }
                            }
                            //-- alleen bij VENT_SYS controleren of VENT_GEM en VENT_LBK nog wel relevant zijn, want bij de dependencyvalidator (checkField) moet het aantal systemen opnieuw bepaald worden.
                            //-- Als ik bv van centraal Dc naar decentraal ga Dd moet mijn aantal systemen op de installatietegels aangepast worden.
                            if (prop.Id === 'VENT_SYS') {
                                isHidden('VENT_GEM', _ventData);
                                isHidden('VENT_LBK', _ventData);
                            }

                            setVentilatorenEigenschappenPerUnit(_ventilatorenData);
                            setVentilatorenEigenschappenPerUnit(_ventilatorenAanvullendData);

                            if (propValueSys === 'VENTSYS_NAT') {
                                //-- Conditie [SQ]
                                ntaMeldingen.warning("[W007]"); //-- Bij een ventilatiesysteem A wijzigen enkele invoerparameters bij het afgiftesysteem van de verwarming. Controleer...
                            }
                        }
                        break;
                    }
                case 'VENT_GEM':
                case 'VENT_LBK':
                    {
                        setVentilatorenEigenschappenPerUnit(_ventilatorenData);
                        setVentilatorenEigenschappenPerUnit(_ventilatorenAanvullendData);
                        break;
                    }
                case 'VOORWARM_NT':
                    {
                        const propRooster = _voorverwarmingProperties['VOORWARM_ROO'];
                        getSelectionTable(propRooster, _voorverwarmingData);
                        setValuesDependingOnSelectionTable();
                        const propdata = prop.getData(entdata);
                        validate(prop, propdata, entdata);
                        break;
                    }
                case 'WARMTETERUG_INV':         // V95
                    {
                        const ventilatiekolom = _ventilatiekolommen.find(kolom => entdata.EntityDataId === kolom.warmteterugwinning.EntityDataId);
                        /// Bij productspecifiek moet het product eerst goed ingevuld zijn, vandaar de timeout
                        setTimeout(() => setDefaultRendementWarmteterugwinning(ventilatiekolom));
                        break;
                    }
                case 'WARMTETERUG_TYPE':        // V23
                    {
                        const ventilatiekolom = _ventilatiekolommen.find(kolom => entdata.EntityDataId === kolom.warmteterugwinning.EntityDataId);
                        setDefaultRendementWarmteterugwinning(ventilatiekolom);
                        break;
                    }
                case 'WARMTETERUG_TYPE_PRDT':   // V96
                    {
                        const ventilatiekolom = _ventilatiekolommen.find(kolom => entdata.EntityDataId === kolom.warmteterugwinning.EntityDataId);
                        setDefaultRendementWarmteterugwinning(ventilatiekolom);
                        setValuesDependingOnSelectionTable();
                        break;
                    }
                case 'WARMTETERUG_BYP':
                case 'WARMTETERUG_FABR':  // V27
                case 'VENTILATOR_FABR':   // V36
                    {
                        if (prop.Id !== 'VENTILATOR_FABR') {
                            const ventilatiekolom = _ventilatiekolommen.find(kolom => entdata.EntityDataId === kolom.warmteterugwinning.EntityDataId);
                            setDefaultBypassAandeel(ventilatiekolom);
                        }

                        if (prop.Id !== 'WARMTETERUG_BYP') {
                            const bouwjaar = ntaSharedLogic.getBouwjaar();
                            const propdata = prop.getData(entdata);

                            /// controleer of de gekozen value nog groter is dat het huidige bouwjaar
                            const codedValue = ntaValidation.codedValues(prop).find(cv => cv.Id === propdata.Value);
                            if (codedValue && parseInt(codedValue.FilterValue1) < bouwjaar) {
                                /// dan moet er een nieuwe waarde bepaald worden voor het fabricagejaar.
                                const defaultValueByBouwjaar = determineFabricagejaar();
                                saveValue(prop, entdata, defaultValueByBouwjaar);
                            }
                        }
                        break;
                    }
                case 'WARMTETERUG_REND':        // V24
                    {
                        //-- Valideer alle velden die afhankelijk zijn van V24
                        validateWarmteterugwinningProp('WARMTETERUG_BYP', entdata);
                        validateWarmteterugwinningProp('WAMRTETERUG_BYPA', entdata);
                        validateWarmteterugwinningProp('WARMTETERUG_TOELI', entdata);
                        break;
                    }
                case 'WAMRTETERUG_BYPA':
                    {
                        isHidden('WARMTETERUG_WTW', entdata);
                        break;
                    }
                case 'VENTZBR_AANW':
                    {
                        //Zwembadruimte-oppervlakte op n.v.t zetten indien niet aangeklikt
                        const zbrAanw_value = prop.getData(entdata).Value;
                        const propZbrAg = _ventzwembadruimteProperties['VENTZBR_AG'];
                        const propdataZbrAg = propZbrAg.getData(entdata);
                        validate(propZbrAg, propdataZbrAg, entdata);
                        if (zbrAanw_value === 'False') {
                            saveValue(propZbrAg, entdata, "n.v.t.");
                        } else {
                            saveValue(propZbrAg, entdata, "");
                        }

                        //Conditie [DP] als versie = ge3-2 EN V89 voor de betreffende rekenzone is aangevinkt dan regel uitgrijzen en geef bij invulvelden 'n.v.t.' aan (Niet aan te passen door gebruiker)
                        const capProps = [_ventcapaciteitenProperties['VENTCAP_ND'], _ventcapaciteitenProperties['VENTCAP_NV'], _ventcapaciteitenProperties['VENTCAP_NAOS'], _ventcapaciteitenProperties['VENTCAP_MD'], _ventcapaciteitenProperties['VENTCAP_MV'] ];
                        const ventzbrRz = ntaEntityData.getFirstParent(entdata, "RZ");
                        for (const ventcap of ntaEntityData.getChildren(_ventData, 'VENTCAP')) {
                            const ventcapRz = ntaEntityData.getFirstParent(ntaEntityData.getFirstParent(ventcap, "UNIT-RZ"), "RZ");
                            if (ventcapRz.EntityDataId === ventzbrRz.EntityDataId) {
                                for (const capProp of capProps) {
                                    if (capProp.getData(ventcap).Relevant) {
                                        let value = "";
                                        if (zbrAanw_value === "True") value = "n.v.t.";
                                        saveValue(capProp, ventcap, value);
                                    }
                                }
                            }
                        }

                        break;
                    }
            }
        } //-- end: validateDependencies ------------------------------------------------------------------------//

        function startFormValidation() {
            return ntaSharedLogic.startFormValidation(getAllEntDatas(), ventilatieLogic);
        } //-- end: startFormValidation ------------------------------------------------------------------------//

        function endFormValidation() {
            return ntaSharedLogic.endFormValidation(getAllEntDatas(), ventilatieLogic);
        } //-- end: endFormValidation ------------------------------------------------------------------------//

        function getAllEntDatas() { // Geeft alle entdatas in één array terug
            return []
                .concat(_ventData, _ventAanvullendData)
                .concat(_warmteterugwinningData, _warmteterugwinningAanvullendData)
                .concat(_ventilatorenData, _ventilatorenAanvullendData)
                .concat(_voorverwarmingData)
                .concat(_ventilatiedebietData)
                .concat(_ventilatiedistributieData)

                .concat(_ventData.tempUnits.map(unit => unit.verblijfsgebied).filter(verblijfsgebied => verblijfsgebied))
                .concat(_ventAanvullendData.tempUnits.map(unit => unit.verblijfsgebied).filter(verblijfsgebied => verblijfsgebied))
                .concat(_warmteterugwinningData.tempUnits.map(unit => unit.toevoerkanaal).filter(toevoerkanaal => toevoerkanaal))
                .concat(_warmteterugwinningAanvullendData.tempUnits.map(unit => unit.toevoerkanaal).filter(toevoerkanaal => toevoerkanaal))

                .concat(_ventilatorenData.tempUnits.flatMap(unit => unit.ventilatorEigenschappen))
                .concat(_ventilatorenAanvullendData.tempUnits.flatMap(unit => unit.ventilatorEigenschappen))
                .concat(_units.flatMap(unit => getUnitRekenzones(unit)).flatMap(unitRz => getVentilatiecapaciteit(unitRz)).filter(ed => ed))
                .concat(ntaEntityData.getChildren(_ventData, 'RZ').flatMap(rz => getVentilatiezwembadruimte(rz)).filter(ed => ed))

                .concat(ntaSharedLogic.getCostEntdata(_installationId))

                .filter(entdata => entdata) // filter alle nulls en undefineds eruit
                ;
        } //-- end: getAllEntDatas ------------------------------------------------------------------------//

        /* Tabellen ************************************************************************************************/
        function createTable11_18() {
            const table11_18 = [
                { Id: 'WARMTETYPE_GEEN',    eta_hr: '0', },
                { Id: 'WARMTETYPE_KOUD',    eta_hr: '0,4', },
                { Id: 'WARMTETYPE_PLABUI',  eta_hr: '0,65', },
                { Id: 'WARMTETYPE_KRUIS',   eta_hr: '0,55', },
                { Id: 'WARMTETYPE_TWEL',    eta_hr: '0,6', },
                { Id: 'WARMTETYPE_WARME',   eta_hr: '0,6', },
                { Id: 'WARMTETYPE_LANG',    eta_hr: '0,7', },
                { Id: 'WARMTETYPE_ENTH',    eta_hr: '0,75', },
                { Id: 'WARMTETYPE_ALUM',    eta_hr: '0,75', },
                { Id: 'WARMTETYPE_KUNS',    eta_hr: '0,8', },
                { Id: 'WARMTETYPE_REN1',    eta_hr: '', },
                { Id: 'WARMTETYPE_REN2',    eta_hr: '', },
                { Id: 'WARMTETYPE_REN3',    eta_hr: '', },
                { Id: 'WARMTETYPE_ONB',     eta_hr: '0', },
            ];

            const warmteterugwinningTypeCodedValues = new Map(_warmteterugwinningProperties["WARMTETERUG_TYPE"].Domain.Codes.map(cv => [cv.Id, cv]));

            for (const row of table11_18) {
                const codedValue = warmteterugwinningTypeCodedValues.get(row.Id);
                row.Value = codedValue?.Value ?? '';
            }

            return table11_18;
        } //-- end: createTable11_18 ------------------------------------------------------------------------//

        function createTableBypass() {
            const tableBypass = [
                { Id: 'WARMTEBYP_GEEN', EtaBypassWKL2010: '0',   EtaBypassWGR2010: '0', EtaBypassU: '0', },
                { Id: 'WARMTEBYP_HON',  EtaBypassWKL2010: '1',   EtaBypassWGR2010: '1', EtaBypassU: '1', },
                { Id: 'WARMTEBYP_BEK',  EtaBypassWKL2010: '0,7', EtaBypassWGR2010: '1', EtaBypassU: '0', },
                { Id: 'WARMTEBYP_ONB',  EtaBypassWKL2010: '0',   EtaBypassWGR2010: '1', EtaBypassU: '0', },
                { Id: 'WERMTEBYP_EIG',  EtaBypassWKL2010: '',    EtaBypassWGR2010: '',  EtaBypassU: '', },
            ];
            const bypassCodedValues = new Map(_warmteterugwinningProperties["WARMTETERUG_BYP"].Domain.Codes.map(cv => [cv.Id, cv]));

            for (const row of tableBypass) {
                const codedValue = bypassCodedValues.get(row.Id);
                row.Value = codedValue?.Value ?? '';
            }

            return tableBypass;
        } //-- end: createTableBypass ------------------------------------------------------------------------//

        function checkUnits() {
            verblijfsgebiedTabelIsHidden(_ventilatieKolom);
            verblijfsgebiedTabelIsHidden(_ventilatieAanvullendKolom);

            const ventverbs = ntaEntityData.getChildren(_ventData, "VENT-VERB")
                .concat(ntaEntityData.getChildren(_ventAanvullendData, "VENT-VERB"));
            for (const verblijfsgebied of ventverbs) {
                validate('VENT-VERB_GEBIED', null, verblijfsgebied);
            }

            // Warmteterugwinning
            warmteterugwinningIsHidden(_ventilatieKolom);
            toevoerkanaalTabelIsHidden(_ventilatieKolom);
            warmteterugwinningIsHidden(_ventilatieAanvullendKolom);
            toevoerkanaalTabelIsHidden(_ventilatieKolom);

            for (const tempUnit of _warmteterugwinningData.tempUnits.concat(_warmteterugwinningAanvullendData.tempUnits)) {
                validate('WARMTE-TOEV-KAN_LEN', null, tempUnit.toevoerkanaal);
            }

            // Ventilatoren
            ventilatorEigenschappenIsHidden(_ventilatieKolom);
            ventilatorEigenschappenIsHidden(_ventilatieAanvullendKolom);
            for (const tempUnit of _ventilatorenData.tempUnits.concat(_ventilatorenAanvullendData.tempUnits)) {
                for (const ventilatoreigenschap of tempUnit.ventilatorEigenschappen) {
                    for (const propdata of ventilatoreigenschap.PropertyDatas) {
                        validate(propdata.PropertyId, propdata, ventilatoreigenschap);
                    }
                }
            }

            // Debieten
            validate('VENTDEB_CAPTAB', null, _ventilatiedebietData);
        } //-- end: checkUnits ------------------------------------------------------------------------//
    }

    return VentilatieLogic;
}]);
